import React, {Fragment, useEffect, useState, useRef} from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import Multiselect from 'multiselect-react-dropdown';
import Select from "react-select";
import Loader from "../../components/Loader/Loader";
import onboardingLottie from '../../assets/images/onboarding_lottie.json';
import {
  Alert,
  Badge,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
  Tooltip,
  Modal, ModalHeader, ModalBody
} from "reactstrap";
import Card from "components/PurpleTheme/Card";
import DocsTooltip from "components/Common/DocsTooltip";
import {Link} from 'react-router-dom';
import {
  getCloudDetails as onGetCloudDetails,
  getMasterNotificationChannels as onGetMasterNotificationChannels,
  getMasterSystems as onGetMasterSystems,
  getNotificationChannels as onGetNotificationChannels,
  getMonitoringSystems as onGetMonitoringSystems,
  postCloudOnboarding,
  postGCPOnboarding,
  postInitialOnboarding,
  postNewRelicOnboarding,
  postOpsGenieOnboarding,
  postPagerdutyOnboarding,
  postApplicationServiceOnboarding,
  postAzureOnboarding,
  postDatadogOnboarding,
  getBluejayMasterCommunicationChannels,
  postSplunkOnboarding,
  postTestAWSCredentials,
  postTestGCPCredentials,
  postTestOCICredentials,
  postTestSentryCredentials,
  postTestAzureCredentials,
  postAppDynamicsOnboarding,
  postDynatraceOnboarding,
  getOnCallPolicies as onGetAllOnCallPolicies,
  getAllAWSAccounts,
  deleteAwsAccount,
  getEncytpedOrgId,
  postOciOnboarding,
  getMasterLoggingSystems as onGetMasterLoggingSystems,
  postSentryOnboarding,
  resetSentryStates,
  getLoggingSystems,
  postTestLokiCredentials,
  postLokiOnboarding,
  resetLokiStates,
  postTestCoralogixCredentials,
  postCoralogixOnboarding,
  resetCoralogixStates,
  getAllAzureAccounts,
  postGrafanaOnboarding,
  getAllGcpProjects, postSignozOnboarding, getNewRelicAccount, deleteNewRelicAccount, postTestSignozCredentials
} from "../../store/actions";
import {showNotification} from "components/Common/notification";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import {useFormik} from "formik";
import {notification_channel_names as NOTIFICATION_CHANNEL} from "../../constants/data_types";
import AddPingMonitoring from "../PingMonitoring/AddPingMonitoring";
import Switch from "react-switch";
import CodeBlock from "../../components/Common/CodeBlock";


const DefaultOnboarding = props => {
  const dispatch = useDispatch();

  const [selectedInfra, setSelectedInfra] = useState({});
  const [selectedMonitoring, setSelectedMonitoring] = useState({});

  const [selectedSynthetics, setSelectedSynthetics] = useState({});
  const [selectedLogging, setSelectedLogging] = useState({});
  const [selectedNotification, setSelectedNotification] = useState({});
  const [selectedServices, setSelectedServices] = useState({});
  const [lastStep, setLastStep] = useState(false);

  const [selectedDatadogSite, setSelectedDatadogSite] = useState(null);

  const [selectedIds, setSelectedIds] = useState([]);

  const [isGCPVerified, setIsGCPVerified] = useState(false);
  const [isAzureVerified, setIsAzureVerified] = useState(false);
  const [tright, settright] = useState(false);
  const [systemsTooltip, setSystemsTooltip] = useState(false);
  const [tooltipGCP, setTooltipGCP] = useState(false);
  const [tooltipAWS, setTooltipAWS] = useState(false);
  const [tooltipAzure, setTooltipAzure] = useState(false);
  const [tooltipNR, setTooltipNR] = useState(false);
  const [tooltipGrafana, setTooltipGrafana] = useState(false);
  const [tooltipSignoz, setTooltipSignoz] = useState(false);
  const [tooltipDatadog, setTooltipDatadog] = useState(false);
  const [tooltipAD, setTooltipAD] = useState(false);
  const [tooltipSplunk, setTooltipSplunk] = useState(false);
  const [tooltipOG, setTooltipOG] = useState(false);
  const [tooltipOci, setTooltipOci] = useState(false);
  const [tooltipPagerDuty, setTooltipPagerduty] = useState(false);
  const [tooltipSentry, setTooltipSentry] = useState(false);
  const [isLokiVerified, setIsLokiVerified] = useState(false);
  const [isOCIVerified, setIsOCIVerified] = useState(false);
  const [isSentryVerified, setIsSentryVerified] = useState(false);
  const [isCoralogixVerified, setIsCoralogixVerified] = useState(false);
  const [instructionsTab, setInstructionsTab] = React.useState('cloud');
  const [newRelicAccountToBeDeleted, setNewRelicAccountToBeDeleted] = useState(false);
  const [isSignozVerified, setIsSignozVerified] = useState(false);

  let {master_systems} = useSelector(state => ({
    master_systems: state.Dashboard.master_systems || []
  }));
  const domain = window.location.hostname;

  useEffect(() => {
    dispatch(getBluejayMasterCommunicationChannels());
  }, [getBluejayMasterCommunicationChannels]);

  const {communication_channels} = useSelector(state => ({
    communication_channels: state.Service.communication_channels,
  }))

  const {test_azure_connection} = useSelector(state => ({
    test_azure_connection: state.Onboarding.test_azure_connection,
  }))

  const {test_signoz_connection} = useSelector(state => ({
    test_signoz_connection: state.Onboarding.test_signoz_connection,
  }))

  const {is_signoz_verifying} = useSelector(state => ({
    is_signoz_verifying: state.Onboarding.is_signoz_verifying,
  }))

  const {test_gcp_connection} = useSelector(state => ({
    test_gcp_connection: state.Onboarding.test_gcp_connection,
  }))

  const {test_oci_connection} = useSelector(state => ({
    test_oci_connection: state.Onboarding.test_oci_connection,
  }))

  const {test_sentry_connection} = useSelector(state => ({
    test_sentry_connection: state.Onboarding.test_sentry_connection,
  }))

  const {test_loki_connection} = useSelector(state => ({
    test_loki_connection: state.Onboarding.test_loki_connection,
  }))

  const {test_aws_connection} = useSelector(state => ({
    test_aws_connection: state.Onboarding.test_aws_connection,
  }))

  const {test_coralogix_connection} = useSelector(state => ({
    test_coralogix_connection: state.Onboarding.test_coralogix_connection,
  }))

  const {is_gcp_verifying} = useSelector(state => ({
    is_gcp_verifying: state.Onboarding.is_gcp_verifying,
  }))

  const {is_azure_verifying} = useSelector(state => ({
    is_azure_verifying: state.Onboarding.is_azure_verifying,
  }))

  const {is_oci_verifying} = useSelector(state => ({
    is_oci_verifying: state.Onboarding.is_oci_verifying,
  }))

  const {is_sentry_verifying} = useSelector(state => ({
    is_sentry_verifying: state.Onboarding.is_sentry_verifying,
  }))

  const {is_loki_verifying} = useSelector(state => ({
    is_loki_verifying: state.Onboarding.is_loki_verifying,
  }))

  const {is_coralogix_verifying} = useSelector(state => ({
    is_coralogix_verifying: state.Onboarding.is_coralogix_verifying,
  }))

  const aws_accounts = useSelector(state => state.Onboarding.aws_accounts || []);

  const new_relic_account = useSelector(state => state.Onboarding.new_relic_account || []);

  const encrypted_org_id = useSelector(state => state.Onboarding.encrypted_org_id);

  const azure_account = useSelector(state => state.Onboarding.azure_account || {});

  const gcp_projects = useSelector(state => state.Onboarding.gcp_projects || []);

  const [isGCPVerifying, setIsGCPVerifying] = useState(is_gcp_verifying || false);
  const [isAzureVerifying, setIsAzureVerifying] = useState(is_azure_verifying || false);
  const [isSignozVerifying, setIsSignozVerifying] = useState(is_signoz_verifying || false);
  const [isOCIVerifying, setIsOCIVerifying] = useState(is_oci_verifying || false);
  const [isSentryVerifying, setIsSentryVerifying] = useState(is_sentry_verifying || false);
  const [allAwsAccounts, setAllAwsAccounts] = useState(aws_accounts);
  const [OCIRegion, setOCIRegions] = useState([])

  const policies = useSelector((state) => state.onCallPolicy.policies || []);
  const availablePolicies = policies?.map((policies) => ({
    id: policies?.id,
    name: policies?.name,
  }));
  const availablePoliciesOptions = availablePolicies?.length > 0
    ? availablePolicies.map((policy) => ({
      label: policy.name,
      value: policy.id,
    }))
    : [];

  useEffect(() => {
    dispatch(onGetAllOnCallPolicies());
  }, [onGetAllOnCallPolicies]);

  useEffect(() => {
    dispatch(getAllAWSAccounts());
    dispatch(getEncytpedOrgId());
    dispatch(getNewRelicAccount());
    dispatch(getAllAzureAccounts())
  }, [getAllAWSAccounts, getEncytpedOrgId, getNewRelicAccount]);

  useEffect(() => {
    setAllAwsAccounts(aws_accounts);
  }, [aws_accounts]);

  useEffect(() => {
    if (test_azure_connection['validated'] === true) {
      setIsAzureVerified(true);
    } else if (test_azure_connection['validated'] === false) {
      showNotification('error', test_azure_connection['message'])
      setIsAzureVerified(false);
    }
  }, [test_azure_connection]);

  useEffect(() => {
    if (test_gcp_connection === "Provided Credentials are valid and successfully verified") {
      setIsGCPVerified(true);
    } else if (test_gcp_connection === "Provided Credentials are invalid") {
      showNotification('error', 'Provided Credentials are invalid')
      setIsGCPVerified(false);
    }
  }, [test_gcp_connection]);

  useEffect(() => {

    if (test_oci_connection === "Provided Credentials are valid and successfully verified") {
      setIsOCIVerified(true);
    } else if (test_oci_connection === "Provided Credentials are invalid") {
      showNotification('error', 'Provided Credentials are invalid')
      setIsOCIVerified(false);
    }
  }, [test_oci_connection]);

  useEffect(() => {
    if (test_sentry_connection === "Provided Credentials are valid and successfully verified") {
      setIsSentryVerified(true);
    } else if (test_sentry_connection === "Provided Credentials are invalid") {
      showNotification('error', 'Provided Credentials are invalid')
      setIsSentryVerified(false);
    }
  }, [test_sentry_connection]);

  useEffect(() => {
    dispatch(resetSentryStates());
    return () => {
      dispatch(resetSentryStates());
    };
  }, []);

  useEffect(() => {
    dispatch(resetLokiStates());
    return () => {
      dispatch(resetLokiStates());
    };
  }, []);

  useEffect(() => {
    if (test_loki_connection === "Provided Credentials are valid and successfully verified") {
      setIsLokiVerified(true);
    } else if (test_loki_connection === "Provided Credentials are invalid") {
      showNotification('error', 'Provided Credentials are invalid')
      setIsLokiVerified(false);
    }
  }, [test_loki_connection]);

  useEffect(() => {
    if (test_aws_connection.status === true) {
      const cardsVerified = [...cardBasedCredentialVerification];
      cardsVerified[test_aws_connection.index] = true;
      setCardBasedCredentialVerification(cardsVerified);
      showNotification('success', test_aws_connection.message)
    } else if (test_aws_connection.status === false) {
      showNotification('error', test_aws_connection.message)
    }
  }, [test_aws_connection, postTestAWSCredentials]);

  useEffect(() => {
    communication_channels.map((channel) => {
      if (["Slack", "Email", "Voice"].includes(channel.name)) {
        const ids = selectedIds
        ids.push(channel.id)
        setSelectedIds(ids)
      }

    })
  }, [communication_channels])

  useEffect(() => {
    if (test_signoz_connection['validated'] === true) {
      setIsSignozVerified(true);
    } else if (test_signoz_connection['validated'] === false) {
      showNotification('error', test_signoz_connection['message'])
      setIsSignozVerified(false);
    }
  }, [test_signoz_connection]);

  const handleVerificationSignoz = () => {
    const values = validation_signoz.values;
    if (deploymentType === 'cloud' && values.controller_url && values.service_token) {
      dispatch(postTestSignozCredentials({
        cloud_onboarding: {
          controller_url: values.controller_url,
          service_token: values.service_token,
          refresh_token: null,
          deploymentType: deploymentType
        }
      }));
    } else if (deploymentType === 'self-hosted' && values.controller_url && values.refresh_token) {
      dispatch(postTestSignozCredentials({
        cloud_onboarding: {
          controller_url: values.controller_url,
          refresh_token: values.refresh_token,
          service_token: null,
          deploymentType: deploymentType
        }
      }));
    } else {
      showNotification("error", "Please enter the required fields");
    }
  };

  const handleVerificationAzure = () => {
    const values = validation_azure.values;
    if (values.subscription_ids && values.client_secret && values.tenant_id && values.client_id) {
      const data = {
        subscription_ids: values.subscription_ids,
        client_secret: values.client_secret,
        tenant_id: values.tenant_id,
        client_id: values.client_id,
      };
      dispatch(postTestAzureCredentials(data));
    } else {
      showNotification("error", "Please enter the required fields");
    }
  };

  const handleVerificationGCP = () => {
    const values = validation_gcp.values;
    if (values.service_account_info && values.gcp_projects.length > 0) {
      const serviceAccountInfoJSON = JSON.parse(values.service_account_info);
      const gcpProjects = values.gcp_projects.split(',').map(project => project.trim())
      const data = {
        gcp_projects: gcpProjects,
        service_account_info: serviceAccountInfoJSON,
      };
      dispatch(postTestGCPCredentials(data));
    } else {
      showNotification("error", "Please enter the Required Fields");
    }
  }

  function handleVerificationOCI() {
    const values = validation_oci.values;
    if (!OCIRegion || OCIRegion.length <= 0) {
      showNotification("error", "Please enter a value in the region");
      return
    }
    if (validation_oci.isValid) {
      const data = {
        "user_id": values?.user_id,
        "fingerprint": values?.fingerprint,
        "tenancy_id": values?.tenancy_id,
        "key_content": values?.key_content,
        "regions": OCIRegion.map(item => item.id),
        "temperstack_ocid": values?.temperstack_ocid,
      }
      dispatch(postTestOCICredentials(data));
    } else {
      showNotification("error", "Please enter the Required Fields");
    }
  }

  const handleVerificationAWS = (index) => {
    const data_to_dispatch = cards[index];
    const type = cards[index].aws_auth_type
    if (type === 'KEY_BASED' && data_to_dispatch.access_key && data_to_dispatch.access_secret && data_to_dispatch.aws_regions.length > 0) {
      const data = {
        aws_auth_type: 'KEY_BASED',
        access_key: data_to_dispatch.access_key,
        access_secret: data_to_dispatch.access_secret,
        aws_region: data_to_dispatch.aws_regions.map(region => region.name),
        index_of_card: index
      }
      dispatch(postTestAWSCredentials(data));
    } else if (type === 'ROLE_BASED' && data_to_dispatch.aws_account_id && data_to_dispatch.aws_role_arn && data_to_dispatch.aws_regions.length > 0) {
      const data = {
        aws_auth_type: 'ROLE_BASED',
        aws_account_id: data_to_dispatch.aws_account_id,
        aws_role_arn: data_to_dispatch.aws_role_arn,
        aws_region: data_to_dispatch.aws_regions.map(region => region.name),
        index_of_card: index
      }
      dispatch(postTestAWSCredentials(data));
    } else {
      showNotification("error", "Please enter the Required Fields");
    }
  };

  // useEffect(() => {
  //   setIsAWSVerifying(is_aws_verifying)
  // }, [is_aws_verifying]);

  useEffect(() => {
    setIsGCPVerifying(is_gcp_verifying)
  }, [is_gcp_verifying]);

  useEffect(() => {
    setIsAzureVerifying(is_azure_verifying)
  }, [is_azure_verifying]);


  useEffect(() => {
    setIsSignozVerifying(isSignozVerifying)
  }, [isSignozVerifying]);

  useEffect(() => {
    setIsOCIVerifying(is_oci_verifying)
  }, [is_oci_verifying]);

  const dataDogSiteOptionGroup = [
    {
      value: "us5",
      label: "us5"
    },
    {
      value: "us3",
      label: "us3"
    },
    {
      value: "us1",
      label: "us1"
    },
    {
      value: "eu",
      label: "eu"
    },
    {
      value: "ap1",
      label: "ap1"
    },
    {
      value: "us1-fed",
      label: "us1-fed"
    }
  ]

  useEffect(() => {
    dispatch(onGetMasterSystems());
    dispatch(onGetMasterLoggingSystems());
  }, [onGetMasterSystems, onGetMasterLoggingSystems]);


  let {master_notification_channels} = useSelector(state => ({
    master_notification_channels: state.Dashboard.master_notification_channels || []
  }));

  let {master_logging_systems} = useSelector(state => ({
    master_logging_systems: state.Dashboard.master_logging_systems || []
  }));

  useEffect(() => {
    dispatch(onGetMasterNotificationChannels());
  }, [onGetMasterNotificationChannels]);

  let {cloud_details} = useSelector(state => ({
    cloud_details: state.Dashboard.cloud_details || []
  }));

  useEffect(() => {
    dispatch(onGetCloudDetails());
  }, [onGetCloudDetails]);

  let {selected_notification_channels} = useSelector(state => ({
    selected_notification_channels: state.Dashboard.notification_channels || []
  }));

  useEffect(() => {
    dispatch(onGetNotificationChannels());
  }, [onGetNotificationChannels]);

  let {current_notification_channels} = useSelector(state => ({
    current_notification_channels: state.Dashboard.notification_channels.map(
      (resource, index) => (resource.name)) || []
  }));

  useEffect(() => {
    dispatch(onGetMonitoringSystems());
    dispatch(getLoggingSystems());
  }, [onGetMonitoringSystems, getLoggingSystems]);

  let {current_monitoring_integrations, current_logging_integrations} = useSelector(state => ({
    current_monitoring_integrations: state.Dashboard.monitoring_systems.map(
      (resource, index) => (resource.name)) || [],
    current_logging_integrations: state.Dashboard.logging_systems.map(
      (resource, index) => (resource.logging_system_name)) || []
  }));

  useEffect(() => {
    // if (cloud_details.length > 0 && selected_notification_channels.length > 0){
    //   cloud_details.map((resource, index) => {
    //     selectedServices[resource['name']] = {
    //       name: resource['name'],
    //       logo: resource['logo_url'],
    //       selected: true,
    //       enabled: true
    //     };
    //   });
    //   selected_notification_channels.map((resource, index) => {
    //     selectedServices[resource['name']] = {
    //       name: resource['name'],
    //       logo: resource['logo_url'],
    //       selected: true,
    //       enabled: true
    //     };
    //   });
    //   setSelectedServices(selectedServices);
    //   setCurrentStep(1);
    //   setTotalSteps(Object.keys(selectedServices).length + 1);
    //   setCurrentService(Object.keys(selectedServices)[0]);
    // }
  }, [cloud_details, selected_notification_channels]);

  const infra_list = ['Amazon Web Services', 'Google Cloud Platform', 'Microsoft Azure', 'Oracle Cloud Infrastructure']

  const disabled_infra = []

  const monitoring_list = ['New Relic', 'App Dynamics', 'Datadog', 'Splunk', 'Dynatrace', 'Grafana', 'Signoz']

  const disabled_monitoring = []

  const disabled_notification = []

  const Synthetics = ['Temperstack']

  const disabled_logging = []

  const logging = ['Sentry', 'Loki', 'Coralogix']

  const disabled_synthetics = []

  const notification_list = ['Email']

  const aws_regions_list = ['us-east-2', 'us-east-1', 'us-west-1', 'us-west-2', 'af-south-1', 'ap-east-1', 'ap-south-2',
    'ap-southeast-3', 'ap-southeast-4', 'ap-south-1', 'ap-northeast-3', 'ap-northeast-2', 'ap-southeast-1', 'ap-southeast-2',
    'ap-northeast-1', 'ca-central-1', 'eu-central-1', 'eu-west-1', 'eu-west-2', 'eu-south-1', 'eu-west-3', 'eu-south-2', 'eu-north-1',
    'eu-central-2', 'me-south-1', 'me-central-1', 'sa-east-1', 'us-gov-east-1', 'us-gov-west-1']

  var region_options = []
  aws_regions_list.map((region, key) => (
    region_options.push({name: region, id: region})
  ))

  const oci_region_list = ['af-johannesburg-1', 'ap-chuncheon-1', 'ap-hyderabad-1', 'ap-melbourne-1',
    'ap-mumbai-1', 'ap-osaka-1', 'ap-seoul-1', 'ap-singapore-1', 'ap-singapore-2', 'ap-sydney-1', 'ap-tokyo-1',
    'ca-montreal-1', 'ca-toronto-1', 'eu-amsterdam-1', 'eu-frankfurt-1', 'eu-jovanovac-1', 'eu-madrid-1',
    'eu-marseille-1', 'eu-milan-1', 'eu-paris-1', 'eu-stockholm-1', 'eu-zurich-1', 'il-jerusalem-1', 'me-abudhabi-1',
    'me-dubai-1', 'me-jeddah-1', 'me-riyadh-1', 'mx-monterrey-1', 'mx-queretaro-1', 'sa-bogota-1', 'sa-santiago-1',
    'sa-saopaulo-1', 'sa-valparaiso-1', 'sa-vinhedo-1', 'uk-cardiff-1', 'uk-london-1', 'us-ashburn-1', 'us-chicago-1',
    'us-phoenix-1', 'us-sanjose-1']

  const oci_region_options = []
  oci_region_list.map((region, key) => (
    oci_region_options.push({name: region, id: region})
  ))

  useEffect(() => {
    if (master_systems.length > 0 && master_notification_channels.length > 0) {
      master_systems.map((resource, index) => {
        if (infra_list.includes(resource.name)) {
          selectedInfra[resource.name] = {
            name: resource.name,
            logo: resource.logo_url,
            selected: false,
            enabled: true
          };
        }
        if (disabled_infra.includes(resource.name)) {
          selectedInfra[resource.name] = {
            name: resource.name,
            logo: resource.logo_url,
            selected: false,
            enabled: false
          };
        }
        if (monitoring_list.includes(resource.name)) {
          selectedMonitoring[resource.name] = {
            name: resource.name,
            logo: resource.logo_url,
            selected: false,
            enabled: true
          };
        }

        if (disabled_monitoring.includes(resource.name)) {
          selectedMonitoring[resource.name] = {
            name: resource.name,
            logo: resource.logo_url,
            selected: false,
            enabled: false
          };
        }
        if (Synthetics.includes(resource.name)) {
          selectedSynthetics[resource.name] = {
            name: resource.name,
            logo: resource.logo_url,
            selected: false,
            enabled: true
          };
        }
        if (disabled_synthetics.includes(resource.name)) {
          selectedSynthetics[resource.name] = {
            name: resource.name,
            logo: resource.logo_url,
            selected: false,
            enabled: false
          };
        }
      });
      setSelectedInfra(selectedInfra);
      setSelectedMonitoring(selectedMonitoring);
      setSelectedSynthetics(selectedSynthetics);

      master_notification_channels.map((resource, index) => {
        if (notification_list.includes(resource.name)) {
          selectedNotification[resource.name] = {
            name: resource.name,
            logo: resource.logo_url,
            selected: false,
            enabled: true
          };
        }
        if (disabled_notification.includes(resource.name)) {
          selectedNotification[resource.name] = {
            name: resource.name,
            logo: resource.logo_url,
            selected: false,
            enabled: false
          };
        }
      });
      setSelectedNotification(selectedNotification);

      master_logging_systems.map((resource, index) => {
        if (logging.includes(resource.name)) {
          selectedLogging[resource.name] = {
            name: resource.name,
            logo: resource.logo_url,
            selected: false,
            enabled: true
          };
        }
        if (disabled_logging.includes(resource.name)) {
          selectedLogging[resource.name] = {
            name: resource.name,
            logo: resource.logo_url,
            selected: false,
            enabled: false
          };
        }
      });
      setSelectedLogging(selectedLogging);

    }
  }, [master_systems, master_notification_channels, master_logging_systems]);

  const handleNotificationSelect = (key) => {
    setIsCardSelected(true);
    if (!selectedNotification[key]['enabled']) {
      return;
    }
    selectedNotification[key]['selected'] = !selectedNotification[key]['selected'];
    setSelectedNotification(selectedNotification);
  }

  const handleSyntheticsSelect = (key) => {
    setIsCardSelected(true);
    if (!selectedSynthetics[key]['enabled']) {
      return;
    }
    selectedSynthetics[key]['selected'] = !selectedSynthetics[key]['selected'];
    setSelectedSynthetics(selectedSynthetics);
  }

  const handleLoggingSelect = (key) => {
    setIsCardSelected(true);
    if (!selectedLogging[key]['enabled']) {
      return;
    }
    selectedLogging[key]['selected'] = !selectedLogging[key]['selected'];
    setSelectedLogging(selectedLogging);
  }

  const handleInfraSelect = (key) => {
    setIsCardSelected(true);
    if (!selectedInfra[key]['enabled']) {
      return;
    }
    selectedInfra[key]['selected'] = !selectedInfra[key]['selected'];
    setSelectedInfra(selectedInfra);
  }

  const handleMonitoringSystemSelect = (key) => {
    setIsCardSelected(true);
    if (!selectedMonitoring[key]['enabled']) {
      return;
    }
    selectedMonitoring[key]['selected'] = !selectedMonitoring[key]['selected'];
    setSelectedMonitoring(selectedMonitoring);
  }

  const handleInitialNext = () => {
    var allSystems = [];
    var allChannels = [];
    Object.keys(selectedInfra).map((key, index) => {
      if (selectedInfra[key]['selected']) {
        selectedServices[key] = {
          name: selectedInfra[key]['name'],
          logo: selectedInfra[key]['logo'],
          selected: true,
          enabled: selectedInfra[key]['enabled']
        };
        allSystems.push(selectedInfra[key]['name']);
      }
    });
    Object.keys(selectedMonitoring).map((key, index) => {
      if (selectedMonitoring[key]['selected']) {
        selectedServices[key] = {
          name: selectedMonitoring[key]['name'],
          logo: selectedMonitoring[key]['logo'],
          selected: true,
          enabled: selectedMonitoring[key]['enabled']
        };
        allSystems.push(selectedMonitoring[key]['name']);
      }
    });
    Object.keys(selectedSynthetics).map((key, index) => {
      if (selectedSynthetics[key]['selected']) {
        selectedServices[key] = {
          name: selectedSynthetics[key]['name'],
          logo: selectedSynthetics[key]['logo'],
          selected: true,
          enabled: selectedSynthetics[key]['enabled']
        };
        allSystems.push(selectedSynthetics[key]['name']);
      }
    });
    Object.keys(selectedLogging).map((key, index) => {
      if (selectedLogging[key]['selected']) {
        selectedServices[key] = {
          name: selectedLogging[key]['name'],
          logo: selectedLogging[key]['logo'],
          selected: true,
          enabled: selectedLogging[key]['enabled']
        };
        allSystems.push(selectedLogging[key]['name']);
      }
    });

    Object.keys(selectedNotification).map((key, index) => {
      if (selectedNotification[key]['selected']) {
        selectedServices[key] = {
          name: selectedNotification[key]['name'],
          logo: selectedNotification[key]['logo'],
          selected: true,
          enabled: selectedNotification[key]['enabled']
        };
        allChannels.push(selectedNotification[key]['name']);
      }
    });
    setSelectedServices(selectedServices);
    setCurrentStep(1);
    setTotalSteps(Object.keys(selectedServices).length + 1);
    setCurrentService(Object.keys(selectedServices)[0]);
  }

  const [totalSteps, setTotalSteps] = useState(4);
  const [currentStep, setCurrentStep] = useState(0);
  const [currentService, setCurrentService] = useState("");
  const [awsRegions, setAwsRegions] = useState([]);

  const [cards, setCards] = useState([
    {
      aws_regions: [],
      access_key: null,
      access_secret: null,
      aws_account_id: null,
      aws_account_name: null,
      aws_role_arn: null,
      cw_agent_enabled: false,
      aws_auth_type: 'KEY_BASED'
    },
  ]);
  const [cardBasedCredentialVerification, setCardBasedCredentialVerification] = useState(cards.map(() => false))

  const validateGCPFunction = async (values) => {
    let errors = {}
    if (!values.gcp_projects) {
      errors['gcp_projects'] = 'Please enter atleast 1 GCP Project'
    }
    //check for aws credentials
    if (!values.service_account_info) {
      errors['service_account_info'] = 'Please enter Service Account Info in JSON Format'
    }
    if (Object.keys(errors).length > 0) {
      return errors;
    }
  }

  const validateAzureFunction = async (values) => {
    let errors = {}

    if (!values.client_id) {
      errors['client_id'] = 'Please enter  App ID'
    }
    if (!values.client_secret) {
      errors['client_secret'] = 'Please enter Azure Secret'
    }

    if (!values.tenant_id) {
      errors['tenant_id'] = 'Please enter Tenant ID'
    }

    if (!values.subscription_ids) {
      errors['subscription_ids'] = 'Please enter Subscription ID'
    }

    if (Object.keys(errors).length > 0) {
      return errors;
    }
  }


  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position: "relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position: "relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#382b42',
      position: "absolute",
      zIndex: 200, // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position: "relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100,
    }),
  };

  const handleAwsRegionSelect = (selectedList, selectedItem, index) => {
    const updatedCards = [...cards];
    updatedCards[index].aws_regions = selectedList;
    setCards(updatedCards);
  };

  const handleAwsRegionRemove = (selectedList, removedItem, index) => {
    const updatedCards = [...cards];
    updatedCards[index].aws_regions = selectedList;
    setCards(updatedCards);
  };

  const [activeTab, setActiveTab] = useState([{active_tab: 'ROLE_BASED'}]);
  const [awsIntegrationType, setAwsIntegrationType] = useState('ROLE_BASED');
  const [touchedFields, setTouchedFields] = useState(
    cards.map(() => ({
      access_key: false,
      access_secret: false,
      aws_account_id: false,
      aws_role_arn: false,
    }))
  );
  const toggleTab = (tab, event, index) => {
    const newTabs = [...activeTab];
    newTabs[index]['active_tab'] = tab;
    setActiveTab(newTabs);
    const updatedCards = [...cards];
    if (tab === 'ROLE_BASED') {
      updatedCards[index].aws_auth_type = 'ROLE_BASED';
      updatedCards[index].access_key = null;
      updatedCards[index].access_secret = null;
      setAwsIntegrationType("ROLE_BASED")
    } else {
      updatedCards[index].aws_auth_type = 'KEY_BASED';
      updatedCards[index].aws_role_arn = null;
      if (index === 0) {
        updatedCards[index].aws_account_id = null;
      }
      setAwsIntegrationType("KEY_BASED")
    }
  };

  const validateCards = (cards) => {
    let isValid = true;

    cards.forEach((card, index) => {
      if (index > 0 && !card.aws_account_id || allAwsAccounts.length > 0 && !card.aws_account_id) {
        showNotification(
          'error',
          `Validation failed for card ${index + 1}: aws account id is required for card ${index + 1}.`
        );
        isValid = false;
      }

      if (card.aws_auth_type === 'ROLE_BASED') {
        if (!card.aws_role_arn || (index > 0 && !card.aws_account_id)) {
          showNotification(
            'error',
            `Validation failed for card ${index + 1}: AWS account id and AWS role arn are required for role-based authentication.`
          );
          isValid = false;
        }
      } else {
        if (!card.access_key || !card.access_secret) {
          showNotification(
            'error',
            `Validation failed for card ${index + 1}: AWS Key and AWS Secret are required for key-based authentication.`
          );
          isValid = false;
        }
      }
      if (card.aws_regions.length === 0) {
        showNotification(
          'error',
          `Validation failed for card ${index + 1}: Please select at least one AWS region.`
        );
        isValid = false;
      }
    });

    return isValid;
  };

  const handleAwsSubmit = () => {
    const isValid = validateCards(cards);

    if (!isValid) {
      return;
    }


    const payload = cards.map((card) => (
      {
        aws_auth_type: card.aws_auth_type,
        access_key: card.access_key,
        access_secret: card.access_secret,
        aws_account_id: card.aws_account_id,
        aws_account_name: card.aws_account_name,
        role_arn: card.aws_role_arn,
        regions: card.aws_regions.map(region => region.name),
        cw_agent_enabled: card.cw_agent_enabled,
        monitoring_system_name: 'Amazon Web Services'
      }));
    if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
      setLastStep(true);
      startLoading();
      dispatch(postCloudOnboarding(payload, true, props.router.navigate));
    } else {
      setCurrentService(Object.keys(selectedServices)[currentStep]);
      setCurrentStep(currentStep + 1);
      dispatch(postCloudOnboarding(payload, false));
    }
  };

  const handleBlur = (index, field) => {
    const newTouched = [...touchedFields];
    newTouched[index] = {
      ...newTouched[index],
      [field]: true
    };
    setTouchedFields(newTouched);
  };
  const shouldShowValidation = (index, field) => {
    return touchedFields[index]?.[field] && !cards[index]?.[field];
  };

  const [defaultOpen, setDefaultOpen] = useState(true);
  const [accordionKey, setAccordionKey] = useState(0);

  const handleClickAccordion = () => {
    setDefaultOpen((prevState) => !prevState);
  };


  const handleAwsInputChange = (value, index, field) => {
    const newCards = [...cards];
    newCards[index][field] = value;
    setCards(newCards);
  };

  const validateJSON = (value) => {
    try {
      JSON.parse(value);//if JSON parse is possible then it is JSON otherwise it is not...this can be a potential logic to check if data is JSON or not....Normal adding of strings or integers or array will not work
      return true;
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    dispatch(getAllGcpProjects());
  }, [getAllGcpProjects]);

  useEffect(() => {
    if (gcp_projects && gcp_projects.length > 0) {
      validation_gcp.setFieldValue('gcp_projects', gcp_projects.join(', '));
    }
  }, [gcp_projects]);

  const validation_gcp = useFormik({
    enableReinitialize: true,
    validate: validateGCPFunction,
    initialValues: {
      gcp_projects: [],
      service_account_info: '',
      ops_agent_enabled: false,
    },
    validationSchema: Yup.object({
      gcp_projects: Yup.string().required("Please Enter AtLeast 1 GCP Project"),
      service_account_info: Yup.string().required("Please Enter the data in JSON Format").test('is-json', 'Invalid JSON format', validateJSON),
    }),
    onSubmit: (values) => {
      const gcpProjectsArray = values.gcp_projects.split(',').map(project => project.trim());
      const serviceAccountInfoJSON = JSON.parse(values.service_account_info);
      const data = {
        gcp_projects: gcpProjectsArray,
        service_account_info: serviceAccountInfoJSON,
        ops_agent_enabled: values.ops_agent_enabled,
        monitoring_system_name: 'GCP',
      }
      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postGCPOnboarding(data, true, props.router.navigate));
      } else {
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postGCPOnboarding(data, false));
      }
    }
  });

  const validation_azure = useFormik({
    enableReinitialize: true,
    validate: validateAzureFunction,
    initialValues: {
      client_id: azure_account?.client_id || '',
      client_secret: '',
      tenant_id: azure_account?.tenant_id || '',
      subscription_ids: azure_account?.subscription_id || ''
    },
    validationSchema: Yup.object({
      client_id: Yup.string().required("Please App ID"),
      client_secret: Yup.string().required("Please enter your client secret"),
      tenant_id: Yup.string().required("Please enter your Tenant ID"),
      subscription_ids: Yup.string().required("Please enter Subscription ID"),
    }),
    onSubmit: (values) => {
      // const azureSubscriptionsArray = values.subscription_ids.split(',').map(project => project.trim());
      const data = {
        subscription_ids: values.subscription_ids,
        client_secret: values.client_secret,
        tenant_id: values.tenant_id,
        client_id: values.client_id,
        monitoring_system_name: "Azure"
      };

      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postAzureOnboarding(data, true, props.router.navigate));
      } else {
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postAzureOnboarding(data, false));
      }
    }
  });

  const validation_app_dynamics = useFormik({
    enableReinitialize: true,
    initialValues: {
      appdynamics_controller_url: '',
      appdynamics_temporary_access_key: '',
    },
    validationSchema: Yup.object({
      appdynamics_controller_url: Yup.string().required("Please Enter Your AppDynamics Controller Url"),
      appdynamics_temporary_access_key: Yup.string().required("Please Enter Your AppDynamics Temporary Access Key"),
    }),
    onSubmit: (values) => {
      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postAppDynamicsOnboarding(values, true, props.router.navigate));
      } else {
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postAppDynamicsOnboarding(values, false));
      }
    }
  })

  const validation_dynatrace = useFormik({
    enableReinitialize: true,
    initialValues: {
      dynatrace_environment_id: '',
      dynatrace_access_token: '',
    },
    validationSchema: Yup.object({
      dynatrace_environment_id: Yup.string().required("Please Enter Your Dynatrace Environment ID"),
      dynatrace_access_token: Yup.string().required("Please Enter Your Dynatrace Access Token"),
    }),
    onSubmit: (values) => {
      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postDynatraceOnboarding(values, true, props.router.navigate));
      } else {
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postDynatraceOnboarding(values, false));
      }
    }
  })


  const validation_nr = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {},
    validationSchema: Yup.object({
      api_key: Yup.string().required("Please Enter Your NR Key"),
      account_id: Yup.string().required("Please Enter Your NR Account ID"),
    }),
    onSubmit: (values) => {
      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postNewRelicOnboarding(values, true, props.router.navigate));
      } else {
        dispatch(postNewRelicOnboarding(values, false));
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postNewRelicOnboarding(values, false));
      }
    }
  });


  const validation_dd = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {},
    validationSchema: Yup.object({
      api_key: Yup.string().required("Please Enter Your Datadog API Key"),
      application_key: Yup.string().required("Please Enter Your Datadog Application Key")
    }),
    onSubmit: (values) => {
      if (selectedDatadogSite === null || selectedDatadogSite.value === "") {
        showNotification("error", "Please select a datadog site");
      }
      values["site"] = selectedDatadogSite.value;
      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postDatadogOnboarding(values, true, props.router.navigate));
      } else {
        dispatch(postDatadogOnboarding(values, false));
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postDatadogOnboarding(values, false));
      }
    }
  });

  const validation_sentry = useFormik({
    enableReinitialize: true,
    initialValues: {
      auth_token: '',
    },
    validationSchema: Yup.object({
      auth_token: Yup.string().required("Please Enter Your Sentry Auth Token"),
    }),
    onSubmit: (values) => {
      if (!isSentryVerified) {
        showNotification("error", "Please verify your credentials before submitting");
        return;
      }
      const data = {
        auth_token: values.auth_token,
      };

      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postSentryOnboarding(data, true, props.router.navigate));
      } else {
        dispatch(postSentryOnboarding(data, false));
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
      }
    }
  });

  const validation_grafana = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {},
    validationSchema: Yup.object({
      controller_url: Yup.string().required("Please Enter Your Grafana Controller URL"),
      service_token: Yup.string().required("Please Enter Your Grafana Service Account Token"),
    }),
    onSubmit: (values) => {
      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postGrafanaOnboarding(values, true, props.router.navigate));
      } else {
        dispatch(postGrafanaOnboarding(values, false));
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postGrafanaOnboarding(values, false));
      }
    }
  });

  const [deploymentType, setDeploymentType] = useState('cloud');
  const validation_signoz = useFormik({
    enableReinitialize: true,

    initialValues: {
      controller_url: '',
      service_token: '',
      refresh_token: ''
    },

    validationSchema: Yup.object().shape({
      controller_url: Yup.string().required("Please Enter Your Signoz Controller URL"),
      service_token: Yup.string().when('deploymentType', {
        is: 'cloud',
        then: () => Yup.string().required("Please Enter Your Signoz Service Account Token"),
        otherwise: () => Yup.string()
      }),
      refresh_token: Yup.string().when('deploymentType', {
        is: 'self-hosted',
        then: () => Yup.string().required("Please Enter Your Signoz Refresh Token"),
        otherwise: () => Yup.string()
      })
    }),

    onSubmit: (values) => {
      const submissionValues = {
        ...values,
        deploymentType
      };

      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postSignozOnboarding(submissionValues, true, props.router.navigate));
      } else {
        dispatch(postSignozOnboarding(submissionValues, false));
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postSignozOnboarding(submissionValues, false));
      }
    }
  });

  useEffect(() => {
    validation_signoz.setFieldValue('deploymentType', deploymentType);
  }, [deploymentType]);

  useEffect(() => {
    if (validation_sentry.values.auth_token === '') {
      setIsSentryVerified(false);
    }
  }, [validation_sentry.values.auth_token]);

  const validateSplunkFunction = async (values) => {
    let errors = {}
    if (!values.splunk_environments) {
      errors['splunk_environments'] = 'Please enter at least 1 Splunk Environment'
    }
    if (!values.realm) {
      errors['realm'] = 'Please enter the realm'
    }

    if (!values.api_key) {
      errors['api_key'] = 'Please enter the api key'
    }

    if (Object.keys(errors).length > 0) {
      return errors;
    }
  }

  const validation_splunk = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,
    validate: validateSplunkFunction,

    initialValues: {},
    validationSchema: Yup.object({
      api_key: Yup.string().required("Please Enter Your Splunk API Key"),
      realm: Yup.string().required("Please Enter Your Splunk Realm"),
      splunk_environments: Yup.string().required("Please enter at least one Splunk Environment")
    }),
    onSubmit: (values) => {
      const splunkEnvironmentsArray = values.splunk_environments.split(',').map(project => project.trim());
      const data = {
        splunk_environments: splunkEnvironmentsArray,
        api_key: values.api_key,
        realm: values.realm
      }
      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postSplunkOnboarding(data, true, props.router.navigate));
      } else {
        dispatch(postSplunkOnboarding(data, false));
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postSplunkOnboarding(data, false));
      }
    }
  });

  const validateOciFunction = async (values) => {
    let errors = {}
    if (!values.key_content) {
      errors['key_content'] = 'Please enter at key content'
    }
    if (!values.tenancy_id) {
      errors['tenancy_id'] = 'Please enter the tenancy id'
    }

    if (!values.fingerprint) {
      errors['fingerprint'] = 'Please enter the fingerprint'
    }
    if (!values.user_id) {
      errors['user_id'] = 'Please enter the user id'
    }
    if (OCIRegion?.length === 0) {
      errors['oci_region'] = 'Please select at least one region'
    }

    if (Object.keys(errors).length > 0) {
      return errors;
    }
  }
  const handleOCIRegionUpdate = (selectedList) => {
    setOCIRegions(selectedList);
  };

  const validation_oci = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,
    validate: validateOciFunction,

    initialValues: {
      user_id: '',
      fingerprint: '',
      tenancy_id: '',
      key_content: '',
      temperstack_ocid: ''
    },
    validationSchema: Yup.object({
      user_id: Yup.string().required("Please Enter Your OCI User ID"),
      fingerprint: Yup.string().required("Please Enter Your OCI Fingerprint"),
      tenancy_id: Yup.string().required("Please enter Your OCI Tenancy ID"),
      key_content: Yup.string().required("Please enter the key content"),
      temperstack_ocid: Yup.string().required("Please enter the created compartment OCID"),
    }),
    onSubmit: (values) => {
      if (!OCIRegion || OCIRegion.length <= 0) {
        showNotification("error", "Please enter a value in the region");
        return
      }
      const regions = OCIRegion.map(item => item.id)
      const data = {
        user_id: values.user_id,
        fingerprint: values.fingerprint,
        tenancy_id: values.tenancy_id,
        key_content: values.key_content,
        regions: regions,
        temperstack_ocid: values.temperstack_ocid,
      }
      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postOciOnboarding(data, true, props.router.navigate));
      } else {
        dispatch(postOciOnboarding(data, false));
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postOciOnboarding(data, false));
      }
    }
  });

  useEffect(() => {
    setIsOCIVerified(false)
  }, [validation_oci.errors]);


  const handleVerificationSentry = () => {
    const values = validation_sentry.values;
    if (values.auth_token) {
      const data = {
        auth_token: values.auth_token,
      };
      dispatch(postTestSentryCredentials(data));
    } else {
      showNotification("error", "Please enter all required fields");
    }
  };
  const validation_opsgenie = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {},
    validationSchema: Yup.object({
      opsgenie_api_key: Yup.string().required("Please Enter Your OpsGenie Key"),
    }),
    onSubmit: (values) => {
      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postOpsGenieOnboarding(values, true, props.router.navigate));
      } else {
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postOpsGenieOnboarding(values, false));
      }
    }
  });

  const validation_pagerduty = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {},
    validationSchema: Yup.object({
      pagerduty_api_key: Yup.string().required("Please Enter Your PagerDuty Key"),
    }),
    onSubmit: (values) => {
      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postPagerdutyOnboarding(values, true, props.router.navigate));
      } else {
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postPagerdutyOnboarding(values, false));
      }
    }
  });

  const validation_application_service = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {},
    validationSchema: Yup.object({
      application_service_name: Yup.string().required("Please Enter Your Application Service Name"),
      group_email: Yup.string().required("Please Enter Your Group Email ID"),
      slack_channel: Yup.string(),
    }),
    onSubmit: (values) => {
      const selectedPolicy = availablePolicies.find(
        (policy) => policy.name === values.on_call_policy
      );
      const payload = {
        ...values,
        selected_notification_channels: selectedIds,
        on_call_policy: selectedPolicy ? selectedPolicy.id : null,
      };
      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postApplicationServiceOnboarding(payload, true, props.router.navigate));
      } else {
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
        dispatch(postApplicationServiceOnboarding(payload, false));
      }
    }
  });

  const handleCheckboxChange = (id, checked) => {
    const updatedIds = checked
      ? [...selectedIds, id]
      : selectedIds.filter(selectedId => selectedId !== id);

    setSelectedIds(updatedIds);

  };

  // const handleCopyIAMPolicy = () => {
  //   window.open('https://snappify.com/view/683edf81-a402-4415-8cb1-154a3b6f9077', '_blank');
  // };

  const IAMPolicyRef = useRef(null);

  const handleIAMPolicyCopy = () => {
    if (IAMPolicyRef.current) {
      const range = document.createRange();
      range.selectNode(IAMPolicyRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);

      try {
        document.execCommand('copy');
        showNotification("success", "Code copied to clipboard");
      } catch (error) {
        console.error('Copy to clipboard failed:', error);
      }

      window.getSelection().removeAllRanges();
    }
  };

  const copyToClipboard = (textToCopy) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => showNotification('success', 'Copied!'))
        .catch(err => console.error('Could not copy text: ', err));
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        showNotification('success', 'Copied!')
      } catch (err) {
        console.error('Could not copy text: ', err);
      }
      document.body.removeChild(textarea);
    }
  };


  const [selectedMulti, setselectedMulti] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteMonitoringSystem, setSelectedDeleteMonitoringSystem] = useState(null);

  function handleMulti(selectedMulti) {
    setselectedMulti(selectedMulti);
  }

  const {error} = useSelector(state => ({
    error: state.Login.error,
  }));

  const [isLoading, setIsLoading] = useState(false);

  const startLoading = () => {
    setIsLoading(true);

    // Simulate loading process
    setTimeout(() => {
      setIsLoading(false);
    }, 10000);
  };

  const [isCardSelected, setIsCardSelected] = useState(false);

  const handleJsonChange = (event) => {
    const userInput = event.target.value;
    validation_gcp.setFieldValue('service_account_info', userInput);

    try {
      const parsedJson = JSON.parse(userInput);
      const formatted = JSON.stringify(parsedJson, null, 2); // Formatting JSON with indentation
      validation_gcp.setFieldValue('service_account_info', userInput);
      validation_gcp.setFieldValue('service_account_info_formatted', formatted);
    } catch (error) {
      //Error handled here...
    }
  };

  const handleDeleteAWSAccount = (monitoring_system_id) => {
    setSelectedDeleteMonitoringSystem(monitoring_system_id);
    setShowDeleteModal(true);
  }

  const handleDeleteNewRelicAccount = (monitoring_system_id) => {
    setSelectedDeleteMonitoringSystem(monitoring_system_id);
    setShowDeleteModal(true);
  }

  const deleteIntegration = () => {
    let payload = {
      monitoring_system_id: selectedDeleteMonitoringSystem
    }
    if (newRelicAccountToBeDeleted) {
      setNewRelicAccountToBeDeleted(false)
      dispatch(deleteNewRelicAccount(payload))
    } else
      dispatch(deleteAwsAccount(payload));
  }
  const addNewCard = () => {
    const oldActiveTab = [...activeTab];
    oldActiveTab.push({active_tab: 'KEY_BASED'});
    setActiveTab(oldActiveTab);
    const existingCards = [...cards];
    existingCards.push({
      aws_regions: [],
      access_key: "",
      aws_account_name: null,
      access_secret: "",
      aws_account_id: "",
      aws_role_arn: "",
      cw_agent_enabled: false,
      aws_auth_type: 'KEY_BASED'
    });
    setCards(existingCards);
    const newTouchedFields = [...touchedFields];
    newTouchedFields.push({
      access_key: false,
      access_secret: false,
      aws_account_id: false,
      aws_role_arn: false,
    });
    setTouchedFields(newTouchedFields);
    const existing_verified_cards = [...cardBasedCredentialVerification];
    existing_verified_cards.push(false);
  };

  const removeCard = (index) => {
    if (cards.length > 1) {
      setCards(cards.filter((_, i) => i !== index));
    }
    if (activeTab.length > 1) {
      setActiveTab(activeTab.filter((_, i) => i !== index));
    }

    const existing_verified_cards = [...cardBasedCredentialVerification];
    existing_verified_cards[index] = false;
    setCardBasedCredentialVerification(existing_verified_cards);
  };

  const validation_loki = useFormik({
    enableReinitialize: true,
    initialValues: {
      url: '',
      username: '',
      password: '',
    },
    validationSchema: Yup.object({
      url: Yup.string().required("Please Enter Your Loki URL"),
      username: Yup.string().required("Please Enter Your Username"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      if (!isLokiVerified) {
        showNotification("error", "Please verify your credentials before submitting");
        return;
      }
      const data = {
        url: values.url,
        username: values.username,
        password: values.password,
      };

      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postLokiOnboarding(data, true, props.router.navigate));
      } else {
        dispatch(postLokiOnboarding(data, false));
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
      }
    }
  });

  useEffect(() => {
    if (validation_loki.values.url === '' ||
      validation_loki.values.username === '' ||
      validation_loki.values.password === '') {
      setIsLokiVerified(false);
    }
  }, [validation_loki.values.url,
    validation_loki.values.username, validation_loki.values.password]);

  const handleVerificationLoki = () => {
    const values = validation_loki.values;
    if (values.url && values.username && values.password) {
      const data = {
        url: values.url,
        username: values.username,
        password: values.password
      };
      dispatch(postTestLokiCredentials(data));
    } else {
      showNotification("error", "Please enter all required fields");
    }
  };

  useEffect(() => {
    dispatch(resetCoralogixStates());
    return () => {
      dispatch(resetCoralogixStates());
    };
  }, []);

  useEffect(() => {
    if (test_coralogix_connection === "Provided Credentials are valid and successfully verified") {
      setIsCoralogixVerified(true);
    } else if (test_coralogix_connection === "Invalid credentials. Please test your credentials again.") {
      showNotification('error', 'Provided Credentials are invalid');
      setIsCoralogixVerified(false);
    }
  }, [test_coralogix_connection]);


  const validation_coralogix = useFormik({
    enableReinitialize: true,
    initialValues: {
      url: '',
      bearer_key: '',
    },
    validationSchema: Yup.object({
      url: Yup.string().required("Please Enter Your Coralogix URL"),
      bearer_key: Yup.string().required("Please Enter Your Bearer Key"),
    }),
    onSubmit: (values) => {
      if (!isCoralogixVerified) {
        showNotification("error", "Please verify your credentials before submitting");
        return;
      }
      const data = {
        url: values.url,
        bearer_key: values.bearer_key,
      };

      if (Object.keys(selectedServices)[Object.keys(selectedServices).length - 1] === currentService) {
        setLastStep(true);
        startLoading();
        dispatch(postCoralogixOnboarding(data, true, props.router.navigate));
      } else {
        dispatch(postCoralogixOnboarding(data, false));
        setCurrentService(Object.keys(selectedServices)[currentStep]);
        setCurrentStep(currentStep + 1);
      }
    }
  });
  useEffect(() => {
    if (validation_coralogix.values.url === '' ||
      validation_coralogix.values.bearer_key === '') {
      setIsCoralogixVerified(false);
    }
  }, [validation_coralogix.values.url, validation_coralogix.values.bearer_key]);

  // Handler for credential verification
  const handleVerificationCoralogix = () => {
    const values = validation_coralogix.values;
    if (values.url && values.bearer_key) {
      const data = {
        url: values.url,
        bearer_key: values.bearer_key
      };
      dispatch(postTestCoralogixCredentials(data));
    } else {
      showNotification("error", "Please enter all required fields");
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          {/* This is the default onboaring screen*/}
          {currentStep === 0 ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <h3 className="">Welcome to Temperstack!</h3>
                  <h5>Temperstack takes less than 10 minutes to set up.</h5>
                </div>
                <Card>
                  <div className="mt-4 mb-4 pl-4">
                    <ul>
                      <li>Temperstack connects with your infrastructure and APM</li>
                      <li>It then pulls all the alerts and resources from these monitoring tools
                      </li>
                      <li>It detects the missing alerts against the recommended list</li>
                      <li>It then allows you to set up all these alerts at the click of a button</li>
                    </ul>
                  </div>
                </Card>
              </Col>

              <Col lg="6" className="left-bordered-div">
                <div>
                  <div className="d-flex align-items-center gap-1 mb-3">
                    <h3>Select Integrations</h3>
                    <span id="systemsTooltip" className="align-items-center p-0 m-0">
                      <i role="button" className="bx bx-help-circle font-size-20 text-white"/>
                    </span>
                  </div>
                  <DocsTooltip
                    placement={"right"}
                    isOpen={systemsTooltip}
                    toggle={() => {
                      setSystemsTooltip(!systemsTooltip);
                    }}
                    targetId={"systemsTooltip"}
                    linkText={'Integrations'}
                    link={"https://docs.temperstack.com/temperstack/getting-started/integrations-hub"}
                  />
                  <Row className="mb-3">
                    <h5>Infrastructure</h5>
                    {
                      Object.keys(selectedInfra).map((key, index) => (
                        <Col lg="2" key={index} className="mb-3">
                          <div
                            className={(selectedInfra[key]['selected'] ? 'cardOnboardingSelected' : 'cardOnboarding')}
                            onClick={() => handleInfraSelect(key)}>
                            <CardBody className="text-center">
                              <img src={selectedInfra[key]['logo']} alt="logo" className="onboarding_logo"/>
                              {current_monitoring_integrations.includes(selectedInfra[key]['name']) ? (
                                <div className="Onboarding-Integrated-Overlay">
                                  <Badge className="font-size-10 badge-soft-success">
                                    Integrated
                                  </Badge>
                                </div>
                              ) : null}
                              <CardTitle className="onboarding_title" tag="h5">
                                {
                                  selectedInfra[key]['name'] === 'Amazon Web Services' ? 'AWS' :
                                    selectedInfra[key]['name'] === 'Google Cloud Platform' ? 'GCP' :
                                      selectedInfra[key]['name'] === 'Microsoft Azure' ? 'Azure' :
                                        selectedInfra[key]['name'] === 'Oracle Cloud Infrastructure' ? 'OCI' :
                                          selectedInfra[key]['name']
                                }
                              </CardTitle>
                            </CardBody>
                          </div>
                        </Col>
                      ))
                    }
                  </Row>
                </div>

                <div>
                  <Row className="mb-4">
                    <h5>Monitoring Tools</h5>
                    {
                      Object.keys(selectedMonitoring).map((key, index) => (
                        <Col lg="2" key={index} className="mb-3">
                          <div
                            className={(selectedMonitoring[key]['selected'] ? 'cardOnboardingSelected' : 'cardOnboarding')}
                            onClick={() => handleMonitoringSystemSelect(key)}>
                            <CardBody className="text-center">
                              <img src={selectedMonitoring[key]['logo']} alt="logo" className="onboarding_logo"/>
                              {current_monitoring_integrations.includes(selectedMonitoring[key]['name']) ? (
                                <div className="Onboarding-Integrated-Overlay">
                                  {/* <img src={cloudDonesvg} alt="Integration done" /> */}
                                  <Badge className="font-size-11 badge-soft-success">
                                    Integrated
                                  </Badge>
                                </div>
                              ) : null}
                              <CardTitle className="onboarding_title" tag="h5">
                                {
                                  selectedMonitoring[key]['name'] === 'App Dynamics' ? 'AppD' :
                                    selectedMonitoring[key]['name']
                                }
                              </CardTitle>
                            </CardBody>
                          </div>
                        </Col>
                      ))
                    }
                  </Row>
                </div>

                {/*<div>*/}
                {/*  <Row className="mb-4">*/}
                {/*    <h5>Notification Channels</h5>*/}
                {/*    {*/}
                {/*      Object.keys(selectedNotification).map((key, index) => (*/}
                {/*        <Col lg="4" key={index} className="mb-3">*/}
                {/*          <div */}
                {/*            className={(selectedNotification[key]['selected'] ? 'cardOnboardingSelected' : 'cardOnboarding')}*/}
                {/*            onClick={() => handleNotificationSelect(key)}>*/}
                {/*            <CardBody className="text-center">*/}
                {/*              <img src={selectedNotification[key]['logo'] === "https://10xbluejay-logos.s3.ap-south-1.amazonaws.com/Email_Notification.png" ? "https://prod-temperstack-public-assets.s3.ap-south-1.amazonaws.com/temperstack-logos/temperstack-emblem.png" : selectedNotification[key]['logo']} alt="logo" className="onboarding_logo" />*/}
                {/*              {current_notification_channels.includes(selectedNotification[key]['name']) ? (*/}
                {/*                <div className="Onboarding-Integrated-Overlay">*/}
                {/*                  /!* <img src={cloudDonesvg} alt="Integration Done" /> *!/*/}
                {/*                  <Badge className="font-size-11 badge-soft-success">*/}
                {/*                    Integrated*/}
                {/*                  </Badge>*/}
                {/*                </div>*/}
                {/*              ) : null}*/}
                {/*              <CardTitle className="onboarding_title" tag="h5">*/}
                {/*                {selectedNotification[key]['name'] === 'Email' ? 'Temperstack' : selectedNotification[key]['name']}*/}
                {/*              </CardTitle>*/}
                {/*            </CardBody>*/}
                {/*          </div>*/}
                {/*        </Col>*/}
                {/*      ))*/}
                {/*    }*/}
                {/*  </Row>*/}
                {/*</div>*/}
                <div>
                  <Row className="mb-4">
                    <h5> Synthetics</h5>
                    {
                      Object.keys(selectedSynthetics).map((key, index) => (
                        <Col lg="2" key={index} className="mb-3">
                          <div
                            className={(selectedSynthetics[key]['selected'] ? 'cardOnboardingSelected' : 'cardOnboarding')}
                            onClick={() => handleSyntheticsSelect(key)}>
                            <CardBody className="text-center">
                              <img
                                src={selectedSynthetics[key]['logo']}
                                alt="logo" className="onboarding_logo"/>
                              {current_monitoring_integrations.includes(selectedSynthetics[key]['name']) ? (
                                <div className="Onboarding-Integrated-Overlay">
                                  {/* <img src={cloudDonesvg} alt="Integration Done" /> */}
                                  <Badge className="font-size-11 badge-soft-success">
                                    Integrated
                                  </Badge>
                                </div>
                              ) : null}
                              <CardTitle className="onboarding_title" tag="h5">
                                Temperstack
                              </CardTitle>
                            </CardBody>
                          </div>
                        </Col>
                      ))
                    }
                  </Row>
                </div>
                <Row className="mb-4">
                  <h5>Logging Systems</h5>
                  {
                    Object.keys(selectedLogging).length > 0 ? (
                      Object.keys(selectedLogging).map((key, index) => (
                        <Col lg="2" key={index} className="mb-3">
                          <div
                            className={(selectedLogging[key]['selected'] ? 'cardOnboardingSelected' : 'cardOnboarding')}
                            onClick={() => handleLoggingSelect(key)}>
                            <CardBody className="text-center">
                              <img
                                src={selectedLogging[key]['logo']}
                                alt="logo" className="onboarding_logo"/>
                              {current_logging_integrations.includes(selectedLogging[key]['name']) ? (
                                <div className="Onboarding-Integrated-Overlay">
                                  <Badge className="font-size-11 badge-soft-success">
                                    Integrated
                                  </Badge>
                                </div>
                              ) : null}
                              <CardTitle className="onboarding_title" tag="h5">
                                {key}
                              </CardTitle>
                            </CardBody>
                          </div>
                        </Col>
                      ))
                    ) : (
                      <Col>
                        <div>No logging systems found</div>
                      </Col>
                    )
                  }
                </Row>

                <div>
                  <Row>
                    <Col lg="6"></Col>
                    <Col lg="6">
                      <button className="btn btn-primary login-button" onClick={() => handleInitialNext()}
                              disabled={!isCardSelected}>Next
                      </button>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row> : null
          }

          {/* This is the AWS onboaring screen*/}

          {currentService === 'Amazon Web Services' ?

            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate AWS</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipAWS"><i
                        className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipAWS}
                      targetId={'tooltipAWS'}
                      toggle={() => setTooltipAWS(!tooltipAWS)}
                      content={'Instructions to integrate '}
                      linkText={'AWS'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-aws-integration'}
                    />
                  </div>
                  <h5>Please login to your AWS account and follow these steps</h5>
                  <h6>Please choose the tab below based on your preferred integration type - </h6>
                </div>
                <div className="card-header">
                  <ul className="nav nav-tabs card-header-tabs">
                    <li className="nav-item me-2" style={{
                      borderRadius: "2px",
                      color: "white",
                      background: awsIntegrationType === "ROLE_BASED" ? "#3569f3" : "#423b3e7a"
                    }}>
                      <a
                        className={`nav-link ${awsIntegrationType === "ROLE_BASED" ? "active" : ""}`}
                        role="tab"
                        style={{color: "white"}}
                        onClick={(e) => setAwsIntegrationType("ROLE_BASED")}
                        aria-controls="ROLE_BASED"
                        aria-selected={awsIntegrationType === "ROLE_BASED"}
                      >
                        Role-Based Integration
                      </a>
                    </li>
                    <li className="nav-item " style={{
                      borderRadius: "2px",
                      color: "white",
                      background: awsIntegrationType === "KEY_BASED" ? "#3569f3" : "#423b3e7a"
                    }}>
                      <a
                        className={`nav-link ${awsIntegrationType === "KEY_BASED" ? "active" : ""}`}
                        style={{color: "white"}}
                        role="tab"
                        onClick={(e) => setAwsIntegrationType("KEY_BASED")}
                        aria-controls="KEY_BASED"
                        aria-selected={awsIntegrationType === "KEY_BASED"}
                      >
                        Key-Based Integration
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="card-body">
                  {awsIntegrationType === "KEY_BASED" ? (
                    <div className="mt-4 mb-5">
                      <div className="section-box mb-4 p-3" style={{borderRadius: '8px'}}>
                        <h5 className="mb-3">Key-Based Integration Steps</h5>
                        <ol>
                          <li>Create an IAM policy with the roles as defined below. You can copy the JSON from below.</li>
                          <li>Create an IAM user and attach the above policy to this user.</li>
                          <li>In addition to attaching the custom IAM policy, make sure to also attach the <strong>ReadOnlyAccess</strong> policy. You can find
                            it under the <em>AWS managed - job function</em> section by searching for "ReadOnlyAccess".
                          </li>
                          <li>Copy the Secret and Key for this user.</li>
                        </ol>
                      </div>
                    </div>
                  ) : (
                    <div className="mt-4 mb-5">
                      <div className="section-box mb-4 p-3" style={{borderRadius: '8px'}}>
                        <h5 className="mb-3">1. Create the IAM Policy</h5>
                        <ol>
                          <li>
                            Open the AWS Management Console and navigate to the <strong>IAM</strong> section. From the left-hand menu,
                            select <strong>Policies</strong>.
                          </li>
                          <li>
                            Click the <strong>Create Policy</strong> button to begin creating a new IAM policy.
                          </li>
                          <li>
                            In the policy creation workflow, go to the <strong>JSON</strong> tab to define the policy.
                          </li>
                          <li>
                            Copy the JSON policy template provided below and paste it into the <strong>JSON</strong> editor.
                          </li>
                          <li>
                            Click on next and give a name to the policy and create the policy.
                          </li>
                        </ol>
                      </div>
                      <div className="section-box mb-4 p-3" style={{borderRadius: '8px'}}>
                        <h5 className="mb-3">2. Create the IAM Role</h5>
                        <ol>
                          <li>
                            Go back to the <strong>IAM</strong> section in the AWS Management Console and select <strong>Roles</strong> from the left-hand menu.
                          </li>
                          <li>
                            Click the <strong>Create role</strong> button to start the role creation process.
                          </li>
                          <li>
                            In the <strong>Trusted entity type</strong> section, choose <strong>AWS account</strong> as the entity type.
                          </li>
                          <li>
                            Select the option <strong>Another AWS account</strong> and enter the following details:
                            <ul>
                              <li>
                                <strong>Account ID:</strong>
                                <i
                                  className="bx bx-copy-alt"
                                  style={{
                                    textAlign: 'center',
                                    marginLeft: 3,
                                    color: 'white',
                                    verticalAlign: 'middle',
                                    fontSize: 'normal',
                                    cursor: 'pointer',
                                    width: '15px',
                                    height: '15px'
                                  }}
                                  onClick={() => copyToClipboard(encrypted_org_id['aws_account_id'])}
                                ></i>
                                <div>
                                    <pre>
                                      <code className="code-snippet">{encrypted_org_id['aws_account_id']}</code>
                                    </pre>
                                </div>
                              </li>
                              <li>
                                <strong>External ID:</strong>
                                <i
                                  className="bx bx-copy-alt"
                                  style={{
                                    textAlign: 'center',
                                    marginLeft: 3,
                                    color: 'white',
                                    verticalAlign: 'middle',
                                    fontSize: 'normal',
                                    cursor: 'pointer',
                                    width: '15px',
                                    height: '15px'
                                  }}
                                  onClick={() => copyToClipboard(encrypted_org_id['encrypted_org_id'])}
                                ></i>
                                <div>
                                    <pre>
                                      <code className="code-snippet">{encrypted_org_id['encrypted_org_id']}</code>
                                    </pre>
                                </div>
                              </li>
                            </ul>
                          </li>
                          <li>
                            Check the option <strong>Require external ID</strong> to ensure secure access between accounts.
                          </li>
                          <li>
                            Click <strong>Next</strong> to proceed to the permissions assignment step.
                          </li>
                          <li>
                            On the permissions screen, locate the IAM policy you created earlier. You can find it by searching for its name in the list. Select
                            the policy to attach it to the role.
                          </li>
                          <li>
                            In addition to attaching the custom IAM policy, make sure to also attach the
                            <strong> ReadOnlyAccess</strong> policy. You can find it under the <em>AWS managed - job function</em> section by searching for "ReadOnlyAccess".
                          </li>
                          <li>
                            Complete the process by clicking the <strong>Create role</strong> button.
                          </li>
                          <li>
                            Once the role is created, locate the Role and copy <strong>ROLE ARN</strong>.
                          </li>
                        </ol>
                      </div>
                    </div>
                  )}
                </div>
                <Card>
                  <CardHeader className="border-bottom text-uppercase">
                    Review IAM policy template
                    <div className="float-end">
                      <button className="btn btn-primary pull-right" onClick={handleIAMPolicyCopy}>
                        Copy to Clipboard
                      </button>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <pre>
                      <code className="code-snippet" ref={IAMPolicyRef}>
                        {`
{
"Version": "2012-10-17",
"Statement": [
  {
    "Sid": "Statement1",
    "Effect": "Allow",
    "Action": [
        "cloudwatch:PutMetricAlarm",
        "cloudwatch:EnableAlarmActions",
        "cloudwatch:DisableAlarmActions",
        "sns:CreateTopic",
        "sns:Subscribe"
    ],
    "Resource": "*"
  },
  {
    "Sid": "PermissionsForEventBus",
    "Effect": "Allow",
    "Action": [
        "events:PutEvents",
        "events:PutRule",
        "events:PutTargets",
        "events:DisableRule",
        "events:EnableRule"
    ],
    "Resource": "*"
  }
  ]
}`.trim()}
                      </code>
                    </pre>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="1">
              </Col>

              <Col lg="5">
                {allAwsAccounts.length > 0 && (
                  <>
                    <h3>Integrated AWS Accounts</h3>
                    {allAwsAccounts.map((account, index) => (
                      <Card className="overflow-hidden mt-2" lg="5" key={index}>
                        <CardBody className="pt-0 account-margin">
                          <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <h5>Onboarded Account {index + 1}</h5>
                          </div>
                          <div className="card-body">
                            <div className="m-2">
                              <Label className="form-label">AWS Auth Type</Label>
                              <Input
                                readOnly={true}
                                name="aws_auth_type"
                                className="form-control"
                                value={account.aws_auth_type === "KEY_BASED" ? "Key-Based" : "Role-Based"}
                              />
                            </div>
                            <div className="m-2">
                              <Label className="form-label">AWS Region</Label>
                              <Input
                                readOnly={true}
                                name="aws_region"
                                className="form-control"
                                value={account.aws_regions.join(", ")}
                              />
                            </div>
                            <div className="m-2">
                              <Label className="form-label">AWS Account ID</Label>
                              <Input
                                readOnly={true}
                                name="aws_account_id"
                                className="form-control"
                                value={account.account_id || "Default"}
                              />
                            </div>
                            <div className="m-2">
                              <Label className="form-label">AWS Alias Account Name</Label>
                              <Input
                                readOnly={true}
                                name="aws_account_name"
                                className="form-control"
                                value={account.account_name}
                              />
                            </div>
                            {account.aws_auth_type === "KEY_BASED" ? (
                              <>
                                <div className="m-2">
                                  <Label className="form-label">AWS Key</Label>
                                  <Input
                                    readOnly={true}
                                    name="access_key"
                                    className="form-control"
                                    type="text"
                                    value={account.aws_access_key_id || ""}
                                  />
                                </div>
                                <div className="m-2">
                                  <Label className="form-label">AWS Secret</Label>
                                  <Input
                                    readOnly={true}
                                    name="access_secret"
                                    className="form-control"
                                    type="text"
                                    value={account.aws_secret_access_key || ""}
                                    placeholder="Enter AWS Secret"
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="m-2">
                                <Label className="form-label">Role ARN</Label>
                                <Input
                                  readOnly={true}
                                  name="aws_role_arn"
                                  className="form-control"
                                  type="text"
                                  value={account.aws_role_arn || ""}
                                />
                              </div>
                            )}
                            <div className="d-flex justify-content-end">
                              <button
                                onClick={() => handleDeleteAWSAccount(account.id)}
                                style={{
                                  backgroundColor: "#dc3545",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  marginTop: "10px"
                                }}
                              >
                                Remove Account
                                <i className="mdi font-size-16 mdi-close"></i>
                              </button>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    ))}
                  </>
                )}
                {cards.map((card, index) => (
                  <Card className="overflow-hidden mt-2" lg="5" key={index}>
                    <CardBody className="pt-0 account-margin">
                      <h3 className="d-inline-flex text-primary">Enter your AWS credentials</h3>
                      <div className="card-header my-1">
                        <ul className="nav nav-tabs card-header-tabs">
                          <li className="nav-item me-2">
                            <a
                              className={`nav-link ${awsIntegrationType === "ROLE_BASED" ? "active" : ""}`}
                              role="tab"
                              onClick={(e) => toggleTab("ROLE_BASED", e, index)}
                              aria-controls="ROLE_BASED"
                              aria-selected={awsIntegrationType === "ROLE_BASED"}
                              style={{
                                borderRadius: "2px",
                                color: "white",
                                background: awsIntegrationType === "ROLE_BASED" ? "#3569f3" : "#423b3e7a"
                              }}
                            >
                              Role-Based
                            </a>
                          </li>
                          <li className="nav-item ">
                            <a
                              className={`nav-link ${awsIntegrationType === "KEY_BASED" ? "active" : ""}`}
                              role="tab"
                              onClick={(e) => toggleTab("KEY_BASED", e, index)}
                              aria-controls="KEY_BASED"
                              aria-selected={awsIntegrationType === "KEY_BASED"}
                              style={{
                                borderRadius: "2px",
                                color: "white",
                                background: awsIntegrationType === "KEY_BASED" ? "#3569f3" : "#423b3e7a"
                              }}
                            >
                              Key-Based
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="card-body">
                        <div className="m-2">
                          <Label className="form-label">AWS Region <span className="text-danger">*</span></Label>
                          <Multiselect
                            name="aws_region"
                            options={region_options}
                            placeholder="Select all that apply"
                            displayValue="name"
                            closeOnSelect={false}
                            onSelect={(selectedList, selectedItem) => handleAwsRegionSelect(selectedList, selectedItem, index)}
                            onRemove={(selectedList, removedItem) => handleAwsRegionRemove(selectedList, removedItem, index)}
                            selectedValues={cards[index]?.aws_regions || []}
                            className="multiselect select2-selection"
                            style={{optionContainer: {backgroundColor: "#382b42"}}}
                          />
                          {/*<div className="invalid-error">{validation.errors.aws_region}</div>*/}
                        </div>
                        {!(index === 0 && card.aws_auth_type === 'KEY_BASED' && allAwsAccounts.length === 0) && (
                          <div className="m-2">
                            <Label className="form-label">AWS Account ID <span className="text-danger">*</span></Label>
                            <Input
                              name="aws_account_id"
                              className="form-control"
                              placeholder="Enter AWS Account ID"
                              type="string"
                              onChange={(e) => handleAwsInputChange(e.target.value, index, 'aws_account_id')}
                              value={cards[index].aws_account_id || ""}
                              onBlur={() => {
                                handleBlur(index, 'aws_account_id');
                              }}
                              invalid={shouldShowValidation(index, 'aws_account_id')}
                            />
                            {shouldShowValidation(index, 'aws_account_id') && (
                              <FormFeedback type="invalid">Please Enter Your AWS Account ID</FormFeedback>
                            )}
                          </div>
                        )}
                        <div className="m-2">
                          <Label className="form-label">
                            AWS Alias Account Name <span style={{fontStyle: "italic", color: "#6c757d"}}>(Optional)</span>
                          </Label>
                          <Input
                            name="aws_account_name"
                            className="form-control"
                            placeholder="Enter AWS Account Name"
                            type="string"
                            onChange={(e) => handleAwsInputChange(e.target.value, index, 'aws_account_name')}
                            value={cards[index].aws_account_name || ""}
                          />
                        </div>
                        {awsIntegrationType === "KEY_BASED" && (
                          <div id="KEY_BASED" className="p-2">
                            <Form
                              className="form-horizontal"
                            >
                              <div className="mb-3">
                                <Label className="form-label">AWS Key <span className="text-danger">*</span></Label>
                                <Input
                                  name="access_key"
                                  className="form-control"
                                  placeholder="Enter AWS Key"
                                  type="string"
                                  onChange={(e) => handleAwsInputChange(e.target.value, index, 'access_key')}
                                  value={cards[index].access_key || ""}
                                  onBlur={() => {
                                    handleBlur(index, 'access_key')
                                  }}
                                  invalid={shouldShowValidation(index, 'access_key')}
                                />
                                {shouldShowValidation(index, 'access_key') && (
                                  <FormFeedback type="invalid">Please Enter Your AWS Key</FormFeedback>
                                )}
                              </div>

                              <div className="mb-3">
                                <Label className="form-label">AWS Secret <span className="text-danger">*</span></Label>
                                <Input
                                  name="access_secret"
                                  value={cards[index].access_secret || ""}
                                  type="text"
                                  placeholder="Enter AWS Secret"
                                  onChange={(e) => handleAwsInputChange(e.target.value, index, 'access_secret')}
                                  onBlur={() => {
                                    handleBlur(index, 'access_secret')
                                  }}
                                  invalid={shouldShowValidation(index, 'access_secret')}
                                />
                                {shouldShowValidation(index, 'access_secret') && (
                                  <FormFeedback type="invalid">Please Enter Your AWS Secret</FormFeedback>
                                )}
                              </div>

                            </Form>
                          </div>
                        )}
                        {awsIntegrationType === "ROLE_BASED" && (
                          <div id="ROLE_BASED" className="p-2">
                            <Form
                              className="form-horizontal"
                            >
                              {error ? <Alert color="danger">{error}</Alert> : null}
                              <div className="mb-3">
                                <Label className="form-label">Role <span className="text-danger">*</span></Label>
                                <Input
                                  name="aws_role_arn"
                                  className="form-control"
                                  placeholder="Enter AWS Role"
                                  type="string"
                                  onChange={(e) => handleAwsInputChange(e.target.value, index, 'aws_role_arn')}
                                  value={cards[index].aws_role_arn || ""}
                                  onBlur={() => {
                                    handleBlur(index, 'aws_role_arn')
                                  }}
                                  invalid={shouldShowValidation(index, 'aws_role_arn')}
                                />
                                {shouldShowValidation(index, 'aws_role_arn') && (
                                  <FormFeedback type="invalid">Please Enter Your AWS Role Arn</FormFeedback>
                                )}
                              </div>
                            </Form>
                          </div>
                        )}
                        <div className="form-check form-check-primary mb-3">
                          <Label className="form-check-label mt-1">Using AWS CloudWatch Agent</Label>
                          <Input
                            className="form-check-input CloudWatchCheckbox me-2"
                            name="cw_agent_enabled"
                            type="checkbox"
                            value={Boolean(cards[index]?.cw_agent_enabled)}
                            onChange={(e) =>
                              handleAwsInputChange(e.target.checked, index, 'cw_agent_enabled')
                            }
                          />
                        </div>
                        <div className="d-flex mt-4 ">
                          {cardBasedCredentialVerification[index] ? (
                            <>
                              <div className="d-inline-flex w-100">
                                <div className="flex items-center justify-between" style={{width: "45%"}}>
                                  <div className="flex items-center">
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() => handleVerificationAWS(index)}
                                    >
                                      Test Connection
                                    </button>
                                    <span
                                      id="TooltipRight"
                                      onMouseOver={() => settright(true)}
                                      onMouseLeave={() => settright(false)}
                                      className="alert-icon inline-flex items-center ml-2"
                                    >
                                      <i className="mdi mdi-information-outline"/>
                                      <Tooltip
                                        placement="top"
                                        isOpen={tright}
                                        target="TooltipRight"
                                        toggle={() => settright(!tright)}
                                        className="border-2 border-yellow-400 rounded-lg bg-gray-800"
                                        style={{zIndex: 1}}
                                      >
                                        We will verify your credentials to fetch your EC2 instances.
                                      </Tooltip>
                                    </span>
                                  </div>
                                  <div className="flex items-center text-success ms-2 mt-2">
                                    Verified
                                    <i className="mdi mdi-check-circle ml-1 ms-2"/>
                                  </div>
                                </div>
                                <div className="d-flex justify-content-end mx-2 ms-4" style={{width: "55%", height: "60%"}}>
                                  {index === cards.length - 1 ? (
                                    <button
                                      onClick={addNewCard}
                                      className="ms-1 mt-1"
                                      style={{
                                        backgroundColor: "green",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "1px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        marginRight: "10px",
                                        marginLeft: "10px"
                                      }}
                                    >
                                      <i className="bx bxs-plus-square font-size-20"></i>
                                    </button>
                                  ) : null}
                                  {index !== 0 ? (
                                    <button
                                      onClick={() => removeCard(index)}
                                      className="ms-1 mt-1"
                                      style={{
                                        backgroundColor: "red",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "1px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <i className="mdi mdi-trash-can font-size-20"
                                         style={{cursor: "pointer", color: "white"}}
                                      ></i>
                                    </button>
                                  ) : null}
                                </div>
                              </div>

                            </>
                          ) : (
                            <div className="d-inline-flex w-100">
                              <div style={{width: "35%"}}>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => handleVerificationAWS(index)}
                                >
                                  Test Connection
                                </button>
                                <span
                                  id="TooltipRight"
                                  onMouseOver={() => settright(true)}
                                  onMouseLeave={() => settright(false)}
                                  className="alert-icon inline-flex items-center ml-2"
                                >
                                      <i className="mdi mdi-information-outline text-yellow-400"/>
                                      <Tooltip
                                        placement="top"
                                        isOpen={tright}
                                        target="TooltipRight"
                                        toggle={() => settright(!tright)}
                                        className="border-2 border-yellow-400 rounded-lg bg-gray-800"
                                        style={{zIndex: 1}}
                                      >
                                        We will verify your credentials to fetch your EC2 instances.
                                      </Tooltip>
                                     </span>
                              </div>
                              <div className="d-flex justify-content-end mx-2 ms-4" style={{width: "65%"}}>
                                {index === cards.length - 1 ? (
                                  <button
                                    onClick={addNewCard}
                                    style={{
                                      backgroundColor: "green",
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: "1px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      marginRight: "10px",
                                      marginLeft: "10px"
                                    }}
                                  >
                                    <i className="bx bxs-plus-square font-size-20"></i>
                                  </button>
                                ) : null}
                                {index !== 0 ? (
                                  <button
                                    onClick={() => removeCard(index)}
                                    className="ms-1"
                                    style={{
                                      backgroundColor: "red",
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: "1px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <i className="mdi mdi-trash-can font-size-20"
                                       style={{cursor: "pointer", color: "white"}}
                                    ></i>
                                  </button>
                                ) : null}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                ))}
                <div className="mt-4">
                  {/*{*/}
                  {/*  lastStep ?*/}
                  {/*      <button className="btn btn-primary login-button">*/}
                  {/*        Saving...*/}
                  {/*      </button> :*/}
                  {/*      //startLoading() :*/}
                  <button
                    onClick={() => handleAwsSubmit()}
                    className="btn btn-primary login-button" type="submit">
                    Save
                  </button>
                  {/*}*/}
                </div>
              </Col>
            </Row> : null
          }

          {/* This is the GCP onboaring screen*/}

          {currentService === 'Google Cloud Platform' ?

            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="d-flex align-items-center gap-2">
                    <h3 className="">Instructions to integrate GCP</h3>
                    <span role="button" style={{marginBottom: "2px"}} id="tooltipGCP"><i
                      className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                  </div>
                  <DocsTooltip
                    placement={'right'}
                    isOpen={tooltipGCP}
                    targetId={'tooltipGCP'}
                    toggle={() => setTooltipGCP(!tooltipGCP)}
                    content={'Instructions to integrate '}
                    linkText={'GCP'}
                    link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-google-cloud-platform-integration'}
                  />
                  <h5>Please login to your GCP account and follow these steps:</h5>
                </div>
                {/*  <div className="mt-4 mb-5">*/}
                {/*    <h5>Step 1: Creating Role</h5>*/}
                {/*    <ul>*/}
                {/*      <li>Add all the Project IDs to be integrated with Temperstack in comma separated format into <i>GCP*/}
                {/*        Project IDs</i> field.*/}
                {/*      </li>*/}
                {/*      <li>Create a new project under your organization.</li>*/}
                {/*      <li>Enable that necessary <a*/}
                {/*          href="https://console.cloud.google.com/apis/api/monitoring.googleapis.com/"> Cloud Montitoring*/}
                {/*        API</a></li>*/}
                {/*      <li>Enable all APIs used by the projects you are integrating with Temperstack.</li>*/}
                {/*      <li>Open Cloud Shell on the GCP Console and create a YAML file.</li>*/}
                {/*      <li>Review and copy the policy template below into an YAML file.</li>*/}
                {/*      <li>Then run the following code to create IAM Role for Temperstack integration: <br/>*/}
                {/*        <div*/}
                {/*          className="mx-2 f-flex"*/}
                {/*          style={{*/}
                {/*            padding: '10px 5px',*/}
                {/*            background: 'rgba(23,23,23,0.45)',*/}
                {/*            display: 'flex',*/}
                {/*            flexDirection: 'row',*/}
                {/*            justifyContent: 'space-between',*/}
                {/*            alignItems: 'center'*/}
                {/*          }}*/}
                {/*        >*/}
                {/*          <code*/}
                {/*            className="code-snippet"*/}
                {/*            style={{*/}
                {/*              fontSize: 'normal',*/}
                {/*              padding: '5px',*/}
                {/*            }}*/}
                {/*          >gcloud iam roles create [ROLE_ID] --organization=[ORG_ID] --file=[YAML_FILE_PATH]</code>*/}
                {/*          <i className="bx bx-copy-alt" style={{*/}
                {/*            textAlign: 'center',*/}
                {/*            verticalAlign: 'middle',*/}
                {/*            fontSize: 'normal',*/}
                {/*            cursor: 'pointer',*/}
                {/*            width: '15px',*/}
                {/*            height: '15px'*/}
                {/*          }} onClick={() => {*/}
                {/*            copyToClipboard("gcloud iam roles create [ROLE_ID] --organization=[ORG_ID] --file=[YAML_FILE_PATH]")*/}
                {/*          }}></i>*/}
                {/*        </div>*/}
                {/*        <ul>*/}
                {/*          <li>You can define the Role ID, e.g., temperstack_custom_role_1.</li>*/}
                {/*          <li>The project ID is the current project ID.</li>*/}
                {/*        </ul>*/}
                {/*      </li>*/}

                {/*      <li>Create a service account for the user in the IAM console and assign the above custom role to*/}
                {/*        the user.*/}
                {/*        <ul>*/}
                {/*          <li>*/}
                {/*            <b>Note:</b> You can identify the custom role by the Role ID in the Custom Role Section.*/}
                {/*          </li>*/}
                {/*        </ul>*/}
                {/*      </li>*/}
                {/*      <li>Create a key for the service account.</li>*/}
                {/*      <li>Copy the JSON service account information into the <i>Service Account Information</i> field on*/}
                {/*        the right.*/}
                {/*      </li>*/}
                {/*      <li>*/}
                {/*        <i>Add this service account as an IAM user to all projects you want to integrate with*/}
                {/*          Temperstack.</i>*/}
                {/*        <ul>*/}
                {/*        <li>Select the Project that is going to be added to Temperstack</li>*/}
                {/*        <li>Under IAM and Admin, Enter IAM</li>*/}
                {/*        <li>Click on the Grant Access Button</li>*/}
                {/*        <li>Enter the Service Account ID as the Principal</li>*/}
                {/*        <li>Add the custom role created as the role</li>*/}
                {/*        <li>Click on save</li>*/}
                {/*      </ul>*/}
                {/*    </li>*/}
                {/*  </ul>*/}
                {/*</div>*/}
                <div className="mt-4 mb-5">
                  <h5>Step 1: Enter GCP Projects for Integration</h5>
                  <ul>
                    <li>Identify the projects that need to be integrated with Temperstack.</li>
                    <li>Add the Project IDs to <i>GCP Project IDs</i> field.(comma separated)</li>
                  </ul>
                  <h5>Step 2: Setting Up the GCP Project</h5>
                  <ul>
                    <li>Create a new project under your organization(say <code>temperstack-integration</code>).</li>
                    <li>Ensure that a billing account is added to this project</li>
                    {/*<li>Enable the necessary <a href="https://console.cloud.google.com/apis/api/monitoring.googleapis.com/">Cloud Monitoring API</a> to <code>temperstack-integration</code>.</li>*/}
                    {/*<li>Enable all APIs used by the projects you are integrating with Temperstack.</li>*/}
                    <li>Enable Cloud Monitoring API on <code>temperstack-integration</code> project</li>
                    <ul>
                      <li>Enable thru GCP Cloud Shell (<b>Recommended</b>)</li>
                      <ul>
                        <li>Open <b>Cloud Shell</b></li>
                        Run the command below in <b>Cloud Shell</b> to set the project to <code>temperstack-integration</code>(newly created project)
                        <CodeBlock
                          displayCode="gcloud config set project temperstack-integration"
                          codeToBeCopied="gcloud config set project temperstack-integration"
                          fontSize="12px"
                        />
                        Run the command below in <b>Cloud Shell</b> enable cloud API need by temperstack
                        <CodeBlock
                          displayCode={'gcloud services enable \\\n' +
                            '  sqladmin.googleapis.com \\\n' +
                            '  sql-component.googleapis.com \\\n' +
                            '  compute.googleapis.com \\\n' +
                            '  run.googleapis.com \\\n' +
                            '  dataflow.googleapis.com \\\n' +
                            '  pubsub.googleapis.com \\\n' +
                            '  redis.googleapis.com \\\n' +
                            '  memcache.googleapis.com \\\n' +
                            '  cloudfunctions.googleapis.com \\\n' +
                            '  container.googleapis.com \\\n' +
                            '  monitoring.googleapis.com\n'
                          }
                          codeToBeCopied={'gcloud services enable \\\n' +
                            '  sqladmin.googleapis.com \\\n' +
                            '  sql-component.googleapis.com \\\n' +
                            '  compute.googleapis.com \\\n' +
                            '  run.googleapis.com \\\n' +
                            '  dataflow.googleapis.com \\\n' +
                            '  pubsub.googleapis.com \\\n' +
                            '  redis.googleapis.com \\\n' +
                            '  memcache.googleapis.com \\\n' +
                            '  cloudfunctions.googleapis.com \\\n' +
                            '  container.googleapis.com \\\n' +
                            '  monitoring.googleapis.com\n'
                          }
                          fontSize="12px"
                        />
                      </ul>
                      <li>Enable the necessary API's manually
                        <ul>
                          <li>Go to <a href="https://console.cloud.google.com/apis/api/monitoring.googleapis.com/">Cloud Monitoring API</a></li>
                          <li>Switch to <code>temperstack-integration</code> project</li>
                          <li>Enable all APIs used by the projects you are integrating with Temperstack.</li>
                        </ul>
                      </li>
                    </ul>
                  </ul>

                  <h5>Step 3: Creating an IAM Role</h5>
                  <ul>
                    <li>Open <b>Cloud Shell</b> on the GCP Console and create a YAML file.
                      <ul>
                        <li>
                          <b>Note:</b> Ensure the shell is <b>not attached to any project</b>, as the role must be
                          created at the <b>organization level</b>. Use the command below to unset the project.
                        </li>

                      </ul>
                      <CodeBlock
                        displayCode="gcloud config unset project"
                        codeToBeCopied="gcloud config unset project"
                        fontSize={"12px"}
                      />
                    </li>
                    <li>Copy the policy template below into the YAML file.</li>
                    <ul>
                      <li>Open a new yaml file called <i>temperstack.yaml</i></li>
                      <CodeBlock displayCode="vi temperstack.yaml" codeToBeCopied="vi temperstack.yaml" fontSize={"12px"}/>
                      <li>
                        <span
                          style={{cursor: 'pointer', color: 'white'}}
                          onClick={handleIAMPolicyCopy}
                        >
                          Copy <i className="bx bx-copy" style={{width: '15px', height: '15px', color: 'white'}}/>
                        </span> the policy template below and paste it into the file
                      </li>
                    </ul>
                    <li>Create the IAM Role for Temperstack integration using the below command(Use Role ID <code>temperstack_custom_role</code>):
                      <ul>
                        <li>Get <code>YOUR_ORG_ID</code>(used in the next step), by running the following command on <b>Cloud Shell</b>
                          <CodeBlock
                            fontSize="12px"
                            displayCode="gcloud organizations list"
                            codeToBeCopied="gcloud organizations list"
                          />
                        </li>
                        <li><b>Note:</b> You can also get the Organization ID from GCP Console.</li>
                        <li>
                          <b>Note:</b> Use the link below to check if you have the <b>Organization Role Administrator
                        </b> permission. Replace <code>YOUR_ORG_ID</code> with your organization ID.
                        </li>
                        <CodeBlock
                          displayCode="https://console.cloud.google.com/iam-admin/iam?organizationId=YOUR_ORG_ID"
                          codeToBeCopied="https://console.cloud.google.com/iam-admin/iam?organizationId=YOUR_ORG_ID"
                          fontSize="12px"
                        />
                      </ul>
                      <CodeBlock
                        displayCode="gcloud iam roles create temperstack_custom_role --organization=YOUR_ORG_ID --file=temperstack.yaml"
                        codeToBeCopied="gcloud iam roles create temperstack_custom_role --organization=YOUR_ORG_ID --file=temperstack.yaml"
                        fontSize={"12px"}
                      />
                    </li>
                  </ul>

                  <h5>Step 4: Creating and Assigning a Service Account</h5>
                  <ul>
                    <li>Switch to <code>temperstack-integration</code> on GCP Console.</li>
                    <li>Search for Service Accounts and got to <i>Service Account - IAM & Admin</i></li>
                    <li>Click on Create Service Account.</li>
                    <li>Enter the Service Account Name (say <i>temperstack-service-account</i>).</li>
                    <li>Add a description</li>
                    <li>Click on Continue.</li>
                    <li>Search for <code>temperstack_custom_role</code> and assign it to the service account.
                    </li>
                    <li>Click on Done(Service Account User Role is not required).</li>
                    <li>Create a key for the service account.</li>
                    <li>Copy the JSON service account information into the <i>Service Account Information</i> field.</li>
                  </ul>

                  <h5>Step 5: Adding Service Account to Projects</h5>
                  <ul>
                    <li>For each project being integrated with Temperstack(used in Step 1).
                      <ul>
                        <li>Go to <b>IAM and Admin</b> in the GCP Console.</li>
                        <li>Click on the <b>Grant Access</b> button.</li>
                        <li>Enter the Service Account ID as the Principal.</li>
                        <li>Assign the custom role <code>temperstack_custom_role</code>.</li>
                        <li>Click on <b>Save</b>.</li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <Card>
                  <CardHeader className="border-bottom text-uppercase">
                    Review IAM policy template
                    <div className="float-end">
                      <button className="btn btn-primary pull-right" onClick={handleIAMPolicyCopy}>
                        Copy to Clipboard
                      </button>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <pre>
                      <code className="code-snippet" ref={IAMPolicyRef}>
                        {`
title: Temperstack_Custom_Role
description: Custom_Role_for_Temperstack
stage: GA
includedPermissions:
- cloudsql.instances.list
- cloudsql.instances.get
- compute.instances.list
- compute.instances.get
- compute.instanceGroupManagers.get
- compute.instanceGroupManagers.list
- compute.instanceGroups.get
- compute.instanceGroups.list
- run.executions.get
- run.executions.list
- run.jobs.get
- run.jobs.list
- run.services.get
- run.services.list
- run.tasks.get
- run.tasks.list
- memcache.instances.get
- memcache.instances.list
- redis.instances.get
- redis.instances.list
- cloudfunctions.functions.get
- cloudfunctions.functions.list
- container.apiServices.get
- container.apiServices.list
- container.clusters.get
- container.clusters.list
- container.deployments.get
- container.deployments.list
- container.namespaces.get
- container.namespaces.list
- container.nodes.get
- container.nodes.list
- container.pods.get
- container.pods.list
- container.nodes.get
- container.nodes.list
- bigtable.instances.get
- bigtable.instances.list
- bigtable.tables.get
- bigtable.tables.list
- bigtable.clusters.get
- bigtable.clusters.list
- storage.buckets.get
- storage.buckets.list
- storage.objects.get
- storage.objects.list
- pubsub.topics.get
- pubsub.topics.list
- pubsub.subscriptions.get
- pubsub.subscriptions.list
- cloudbuild.builds.get
- cloudbuild.builds.list
- dataflow.jobs.get
- dataflow.jobs.list
- monitoring.alertPolicies.get
- monitoring.alertPolicies.list
- monitoring.alertPolicies.create
- monitoring.alertPolicies.update
- monitoring.notificationChannelDescriptors.get
- monitoring.notificationChannelDescriptors.list
- monitoring.notificationChannels.create
- monitoring.notificationChannels.get
- monitoring.notificationChannels.list
- monitoring.notificationChannels.update
- monitoring.notificationChannels.verify
- monitoring.notificationChannels.sendVerificationCode
- spanner.instances.get
- spanner.instances.list
- spanner.instances.update
- cloudnotifications.activities.list
- monitoring.dashboards.get
- monitoring.dashboards.list
- monitoring.dashboards.create
- monitoring.groups.create
- monitoring.groups.get
- monitoring.groups.list
- monitoring.metricDescriptors.get
- monitoring.metricDescriptors.list
- monitoring.metricDescriptors.create
- monitoring.notificationChannelDescriptors.get
- monitoring.notificationChannelDescriptors.list
- monitoring.monitoredResourceDescriptors.get
- monitoring.monitoredResourceDescriptors.list
- monitoring.notificationChannels.create
- monitoring.notificationChannels.get
- monitoring.notificationChannels.list
- monitoring.notificationChannels.sendVerificationCode
- monitoring.notificationChannels.update
- monitoring.notificationChannels.verify
- monitoring.services.get
- monitoring.services.list
- redis.clusters.get
- redis.clusters.list
- redis.clusters.update`.trim()}
                      </code>
                    </pre>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="1">
              </Col>

              <Col lg="5">
                <Card className="overflow-hidden" lg="5">
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your GCP credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_gcp.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">GCP Project IDs</Label>
                          <Input
                            name="gcp_projects"
                            value={validation_gcp.values.gcp_projects || ""}
                            type="text"
                            placeholder="Enter GCP Project IDs(comma(,) separated for multiple projects)"
                            onChange={e => validation_gcp.setFieldValue('gcp_projects', e.target.value)}
                            onBlur={validation_gcp.handleBlur}
                            invalid={
                              validation_gcp.touched.gcp_projects && validation_gcp.errors.gcp_projects ? true : false
                            }
                          />
                          {validation_gcp.touched.gcp_projects && validation_gcp.errors.gcp_projects ? (
                            <FormFeedback type="invalid">{validation_gcp.errors.gcp_projects}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Service Account Information</Label>
                          <textarea
                            name="service_account_info"
                            value={validation_gcp.values.service_account_info || ''}
                            placeholder="Enter Service Account Information in JSON Format"
                            onChange={handleJsonChange}
                            onBlur={validation_gcp.handleBlur}
                            rows={10}
                            className={
                              validation_gcp.touched.service_account_info &&
                              validation_gcp.errors.service_account_info
                                ? 'form-control is-invalid'
                                : 'form-control'
                            }
                          />
                          {validation_gcp.touched.service_account_info &&
                          validation_gcp.errors.service_account_info ? (
                            <FormFeedback type="invalid">
                              {validation_gcp.errors.service_account_info}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="form-check form-check-primary mb-3">
                          <Label className="form-check-label mt-1">Using OPS Agent </Label>
                          <Input className="form-check-input OpsAgentCheckbox me-2"
                                 name="ops_agent_enabled"
                                 value={validation_gcp.values.ops_agent_enabled || false}
                                 type="checkbox"
                                 onChange={validation_gcp.handleChange}
                          />
                        </div>
                        <div style={{display: "flex", alignItems: "center", marginTop: "20px"}}>
                          {!isGCPVerified ? (
                            isGCPVerifying ? (
                              <div>
                                <Spinner className="ms-2" color="primary"/>
                              </div>
                            ) : (
                              <div style={{display: "flex", alignItems: "center"}}>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={handleVerificationGCP}
                                >
                                  Test Connection
                                </button>
                                <span
                                  id="TooltipRight"
                                  onMouseOver={() => settright(true)}
                                  onMouseLeave={() => settright(false)}
                                  className="alert-icon"
                                  style={{marginLeft: "10px", display: "inline-flex", alignItems: "center"}}
                                >
                                    <i className="mdi mdi-information-outline text-warning"/>
                                    <Tooltip
                                      placement="top"
                                      isOpen={tright}
                                      target="TooltipRight"
                                      toggle={() => settright(!tright)}
                                      style={{
                                        border: "2px solid #f1b44c",
                                        borderRadius: "10px",
                                        backgroundColor: "#2a3042",
                                        zIndex: 1,
                                      }}
                                    >
                                      We will verify your credentials to fetch Compute Instances. If you are not using Compute Instances, you can ignore this step.
                                    </Tooltip>
                                  </span>
                              </div>
                            )
                          ) : (
                            <div style={{alignContent: "center", display: "flex", justifyContent: "space-between"}}>
                              <div className='text-success' color="success">Verified</div>
                              <i className="mdi mdi-check-circle text-success" style={{marginLeft: "5px"}}/>
                            </div>
                          )}
                        </div>
                        <div className="mt-4">
                          {
                            lastStep ?
                              <button className="btn btn-primary login-button">
                                Saving...
                              </button> :
                              <button className="btn btn-primary login-button" type="submit">
                                Save
                              </button>
                          }
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }

          {/*This is the Azure onboarding Screen*/}

          {currentService === 'Microsoft Azure' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate Azure</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipAzure"><i className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipAzure}
                      targetId={'tooltipAzure'}
                      toggle={() => setTooltipAzure(!tooltipAzure)}
                      content={'Instructions to integrate '}
                      linkText={'Azure'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-microsoft-azure-integration'}
                    />
                  </div>
                  <h5>Please login to your Azure account and follow these steps:</h5>
                </div>
                <div className="mt-4 mb-5">
                  <ol>
                    <li><strong>Register a New Application:</strong>
                      <ol>
                        <li>Open the Azure portal and search for "App Registrations".</li>
                        <li>Click "New registration", name the application "Temperstack", and click "Register".</li>
                      </ol>
                    </li>
                    <li><strong>Get Subscription ID:</strong>
                      <ol>
                        <li>Navigate to "Subscriptions", select the relevant one, and copy the "Subscription ID".</li>
                      </ol>
                    </li>
                    <li><strong>Get Tenant ID:</strong>
                      <ol>
                        <li>Go to "Microsoft Entra ID" and copy the "Tenant ID".</li>
                      </ol>
                    </li>
                    <li><strong>Get Client ID:</strong>
                      <ol>
                        <li>Return to "App registrations", select "Temperstack", and copy the "Client ID".
                        </li>
                      </ol>
                    </li>
                    <li><strong>Create Client Secret:</strong>
                      <ol>
                        <li>In "Temperstack" application, go to "Certificates & secrets" and click "New client secret".</li>
                        <li>Provide a description, set an expiration, click "Add", and copy the "Value" (Not Client Secret ID).</li>
                      </ol>
                    </li>
                    <li>
                      Please make sure your subscription is registered to
                      use <strong>microsoft.insights</strong> namespace.
                      If not follow the steps below:
                      <ol>
                        <li>Go to "Subscriptions" and select the subscription.</li>
                        <li>Under "Settings" in the left side menu, click on "Resource providers".</li>
                        <li>Search for "Microsoft.Insights" and click "Register".</li>
                      </ol>
                    </li>
                  </ol>
                </div>
                <div>
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h5 className="">Detailed integration steps <Link target='_blank'
                                                                        to={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-microsoft-azure-integration/creating-access-for-temperstack-in-azure'}>here</Link>
                      </h5>
                    </div>
                  </div>
                </div>
                <Card>
                  <CardHeader className="border-bottom text-uppercase">
                    Instructions to Follow in Azure Portal
                  </CardHeader>
                  <CardBody>
                    <pre>
                      <code className="code-snippet" ref={IAMPolicyRef}>
                        {`
Steps to follow:
1. Under Subscription and navigate to IAM.
2. Select "Add" > "Add role assignment"
3. Select "Reader" as role.
4. Proceed to "+ Select members"
   - Search and select the application you created(Temperstack or Custom app name).
5. Click on "Review and Assign."
6. Repeat steps 2-5 for the following roles:
   - Application Insights Component Contributor.
   - Automation Contributor.`.trim()}
                      </code>
                    </pre>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="1">
              </Col>

              <Col lg="5">
                <Card className="overflow-hidden" lg="5">
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your Azure credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_azure.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">Azure Subscription ID</Label>
                          <Input
                            name="subscription_ids"
                            value={validation_azure.values.subscription_ids || ""}
                            type="text"
                            placeholder="Enter Subscription ID"
                            onChange={e => validation_azure.setFieldValue('subscription_ids', e.target.value)}
                            onBlur={validation_azure.handleBlur}
                            invalid={
                              !!(validation_azure.touched.subscription_ids && validation_azure.errors.subscription_ids)
                            }
                          />
                          {validation_azure.touched.subscription_ids && validation_azure.errors.subscription_ids ? (
                            <FormFeedback type="invalid">{validation_azure.errors.subscription_ids}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Tenant ID</Label>
                          <Input
                            name="tenant_id"
                            className="form-control"
                            placeholder="Enter Azure Tenant ID"
                            type="string"
                            onChange={validation_azure.handleChange}
                            onBlur={validation_azure.handleBlur}
                            value={validation_azure.values.tenant_id || ""}
                            invalid={
                              !!(validation_azure.touched.tenant_id && validation_azure.errors.tenant_id)
                            }
                          />
                          {validation_azure.touched.tenant_id && validation_azure.errors.tenant_id ? (
                            <FormFeedback type="invalid">{validation_azure.errors.tenant_id}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Client ID</Label>
                          <Input
                            name="client_id"
                            className="form-control"
                            placeholder="Enter Azure Client ID"
                            type="string"
                            onChange={validation_azure.handleChange}
                            onBlur={validation_azure.handleBlur}
                            value={validation_azure.values.client_id || ""}
                            invalid={
                              !!(validation_azure.touched.client_id && validation_azure.errors.client_id)
                            }
                          />
                          {validation_azure.touched.client_id && validation_azure.errors.client_id ? (
                            <FormFeedback type="invalid">{validation_azure.errors.client_id}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Client Secret</Label>
                          <Input
                            name="client_secret"
                            className="form-control"
                            placeholder="Enter Azure Client Secret Value"
                            type="string"
                            onChange={validation_azure.handleChange}
                            onBlur={validation_azure.handleBlur}
                            value={validation_azure.values.client_secret || ""}
                            invalid={
                              !!(validation_azure.touched.client_secret && validation_azure.errors.client_secret)
                            }
                          />
                          {validation_azure.touched.client_secret && validation_azure.errors.client_secret ? (
                            <FormFeedback type="invalid">{validation_azure.errors.client_secret}</FormFeedback>
                          ) : null}
                          <div style={{display: "flex", alignItems: "center", marginTop: "20px"}}>
                            {!isAzureVerified ? (
                              isAzureVerifying ? (
                                <div>
                                  <Spinner className="ms-2" color="primary"/>
                                </div>
                              ) : (
                                <div style={{display: "flex", alignItems: "center"}}>
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleVerificationAzure}
                                  >
                                    Test Connection
                                  </button>
                                  <span
                                    id="TooltipRight"
                                    onMouseOver={() => settright(true)}
                                    onMouseLeave={() => settright(false)}
                                    className="alert-icon"
                                    style={{marginLeft: "10px", display: "inline-flex", alignItems: "center"}}
                                  >
                                    <i className="mdi mdi-information-outline text-warning"/>
                                    <Tooltip
                                      placement="top"
                                      isOpen={tright}
                                      target="TooltipRight"
                                      toggle={() => settright(!tright)}
                                      style={{
                                        border: "2px solid #f1b44c",
                                        borderRadius: "10px",
                                        backgroundColor: "#2a3042",
                                        zIndex: 1,
                                      }}
                                    >
                                      We will verify your credentials to access Resource Groups from your Azure subscription.
                                    </Tooltip>
                                  </span>
                                </div>
                              )
                            ) : (
                              <div style={{alignContent: "center", display: "flex", justifyContent: "space-between"}}>
                                <div className='text-success' color="success">Verified</div>
                                <i className="mdi mdi-check-circle text-success" style={{marginLeft: "5px"}}/>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mt-4">
                          {
                            lastStep ?
                              <button className="btn btn-primary login-button">
                                Saving...
                              </button> :
                              <button className="btn btn-primary login-button" type="submit">
                                Save
                              </button>
                          }
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }

          {currentService === 'App Dynamics' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Integrating AppDynamics with Temperstack</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipAD"><i className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipAD}
                      targetId={'tooltipAD'}
                      toggle={() => setTooltipAD(!tooltipAD)}
                      content={'Instructions to integrate '}
                      linkText={'AppDynamics'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-appdynamics-integration'}
                    />
                  </div>
                  <h5>Prerequisites:</h5>
                  <ul>
                    <li>Account Owner permission in AppDynamics</li>
                    <li>Logged in to AppDynamics account</li>
                  </ul>
                </div>
                <div className="mt-4 mb-5">
                  <h5>Integration Steps:</h5>
                  <ol>
                    <li>Navigate to Settings {'>'} Administration {'>'} API Clients</li>
                    <li>Click "Create a New API Key"</li>
                    <li>Enter a Client Name</li>
                    <li>Click "Generate Secret"</li>
                    <li>Click "Save"</li>
                    <li>On the same screen, click <strong>Generate Temporary Access Token</strong></li>
                    <li>Set token expiration to 30 days</li>
                    <li>Copy the <strong>Temporary Access Token</strong> [Not the client secret]</li>
                    <li>Click "Add Roles" and give below permissions</li>
                    <ul>
                      <li>
                        <strong>Account Owner</strong>
                      </li>
                      <li>
                        <strong>Administrator</strong>
                      </li>
                    </ul>
                    <li>Enter Controller URL
                      <ul>
                        <li>This can be found in your App Dynamics login URL</li>
                        <li>Format: <strong><code>"https://[your-instance].saas.appdynamics.com"</code></strong></li>
                      </ul>
                    </li>
                  </ol>
                </div>
              </Col>
              <Col lg="1">
              </Col>

              <Col lg="5">
                <Card className="" lg="5">
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your App Dynamics credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_app_dynamics.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">Temporary Access Token</Label>
                          <Input
                            name="appdynamics_temporary_access_key"
                            className="form-control"
                            placeholder="App Dynamics Temporary Access Token"
                            type="string"
                            onChange={validation_app_dynamics.handleChange}
                            onBlur={validation_app_dynamics.handleBlur}
                            value={validation_app_dynamics.values.appdynamics_temporary_access_key || ""}
                            invalid={(!!(validation_app_dynamics.touched.appdynamics_temporary_access_key &&
                              validation_app_dynamics.errors.appdynamics_temporary_access_key))}
                          />
                          {
                            validation_app_dynamics.touched.appdynamics_temporary_access_key &&
                            validation_app_dynamics.errors.appdynamics_temporary_access_key ? (
                              <FormFeedback type="invalid">
                                {validation_app_dynamics.errors.appdynamics_temporary_access_key}
                              </FormFeedback>
                            ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">App Dynamics Controller Url</Label>
                          <Input
                            name="appdynamics_controller_url"
                            className="form-control"
                            placeholder="App Dynamics Controller Url"
                            type="string"
                            onChange={validation_app_dynamics.handleChange}
                            onBlur={validation_app_dynamics.handleBlur}
                            value={validation_app_dynamics.values.appdynamics_controller_url || ""}
                            invalid={(!!(validation_app_dynamics.touched.appdynamics_controller_url &&
                              validation_app_dynamics.errors.appdynamics_controller_url))}
                          />
                          {validation_app_dynamics.touched.appdynamics_controller_url &&
                          validation_app_dynamics.errors.appdynamics_controller_url ? (
                            <FormFeedback type="invalid">
                              {validation_app_dynamics.errors.appdynamics_controller_url}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mt-4">
                          {
                            lastStep ?
                              <button className="btn btn-primary login-button">
                                Saving...
                              </button> :
                              //startLoading() :
                              <button
                                className="btn btn-primary login-button"
                                type="submit"
                              >
                                Save
                              </button>
                          }
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }

          {currentService === 'Dynatrace' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <h3>Integrating Dynatrace with Temperstack</h3>
                </div>
                <div className="mt-4 mb-5">
                  <h5>Integration Steps:</h5>
                  <ol>
                    <li>Log in to Dynatrace</li>
                    <li>Search for Access Tokens</li>
                    <li>Click "Generate new token"</li>
                    <li>Leave this expiration date field & Template field as empty</li>
                    <li>In Scopes select below scopes & Generate the token</li>
                    <ul>
                      <li>
                        <strong>Read Entities</strong>
                      </li>
                      <li>
                        <strong>Read Metrics</strong>
                      </li>
                      <li>
                        <strong>Read Settings</strong>
                      </li>
                      <li>
                        <strong>Write settings</strong>
                      </li>
                      <li>
                        <strong>Write entities</strong>
                      </li>
                      <li>
                        <strong>Read configuration</strong>
                      </li>
                      <li>
                        <strong>Write configuration</strong>
                      </li>
                      <li>
                        <strong>User sessions</strong>
                      </li>
                    </ul>
                    <li>Enter the environment ID
                      <ul>
                        <li>Click on profile</li>
                        <li>Hover on the Environments</li>
                        <li>Copy the Environment Id</li>
                      </ul>
                    </li>
                  </ol>
                </div>
              </Col>
              <Col lg="1">
              </Col>

              <Col lg="5">
                <Card className="" lg="5">
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your Dynatrace credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_dynatrace.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">Environment Id</Label>
                          <Input
                            name="dynatrace_environment_id"
                            className="form-control"
                            placeholder="Dynatrace Environment ID"
                            type="string"
                            onChange={validation_dynatrace.handleChange}
                            onBlur={validation_dynatrace.handleBlur}
                            value={validation_dynatrace.values.dynatrace_environment_id || ""}
                            invalid={(!!(validation_dynatrace.touched.dynatrace_environment_id &&
                              validation_dynatrace.errors.dynatrace_environment_id))}
                          />
                          {
                            validation_dynatrace.touched.dynatrace_environment_id &&
                            validation_dynatrace.errors.dynatrace_environment_id ? (
                              <FormFeedback type="invalid">
                                {validation_dynatrace.errors.dynatrace_environment_id}
                              </FormFeedback>
                            ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Access Key</Label>
                          <Input
                            name="dynatrace_access_token"
                            className="form-control"
                            placeholder="Dynatrace Access token"
                            type="string"
                            onChange={validation_dynatrace.handleChange}
                            onBlur={validation_dynatrace.handleBlur}
                            value={validation_dynatrace.values.dynatrace_access_token || ""}
                            invalid={(!!(validation_dynatrace.touched.dynatrace_access_token &&
                              validation_dynatrace.errors.dynatrace_access_token))}
                          />
                          {validation_dynatrace.touched.dynatrace_access_token &&
                          validation_dynatrace.errors.dynatrace_access_token ? (
                            <FormFeedback type="invalid">
                              {validation_dynatrace.errors.dynatrace_access_token}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mt-4">
                          {
                            lastStep ?
                              <button className="btn btn-primary login-button">
                                Saving...
                              </button> :
                              //startLoading() :
                              <button
                                className="btn btn-primary login-button"
                                type="submit"
                              >
                                Save
                              </button>
                          }
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }

          {/* This is the NR onboarding screen*/}

          {currentService === 'New Relic' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate New Relic</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipNR"><i className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipNR}
                      targetId={'tooltipNR'}
                      toggle={() => setTooltipNR(!tooltipNR)}
                      content={'Instructions to integrate '}
                      linkText={'New Relic'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-newrelic-integration'}
                    />
                  </div>
                  <h5>Login to New Relic and follow these steps</h5>
                </div>
                <div className="mt-4 mb-5">
                  <ol>
                    <li>Navigate to Profile{'>'}API Keys</li>
                    <li>Click on "Create a key"</li>
                    <li>Select the account you'd like to use</li>
                    <li>Select the Key type as "User"</li>
                    <li>Type a suitable name for this key and notes, if any</li>
                    <li>Click on "Create a key"</li>
                    <li>Copy the account ID and key value</li>
                  </ol>
                </div>
              </Col>

              <Col lg="1">
              </Col>

              <Col lg="5">
                {new_relic_account?.length > 0 ?
                  <>
                    <h3>Integrated NewRelic Account</h3>
                    <Card className="overflow-hidden mt-2" lg="5">
                      <CardBody className="pt-0 account-margin">
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                          <h5>Onboarded Account</h5>
                        </div>
                        <div className="card-body">
                          <div className="m-2">
                            <Label className="form-label">NR Key</Label>
                            <Input
                              readOnly={true}
                              name="new_relic_key"
                              className="form-control"
                              value={new_relic_account[0]?.api_key}
                            />
                          </div>
                          <div className="m-2">
                            <Label className="form-label">NR Account ID</Label>
                            <Input
                              readOnly={true}
                              name="new_relic_account_id"
                              className="form-control"
                              value={new_relic_account[0]?.account_id || "Default"}
                            />
                          </div>
                          <div className="d-flex justify-content-end">
                            <button
                              onClick={() => {
                                setNewRelicAccountToBeDeleted(true)
                                handleDeleteNewRelicAccount(new_relic_account[0]?.id)
                              }}
                              style={{
                                backgroundColor: "#dc3545",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                marginTop: "10px"
                              }}
                            >
                              Remove Account
                              <i className="mdi font-size-16 mdi-close"></i>
                            </button>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </> : <Card className="overflow-hidden" lg="5">
                    <CardBody className="pt-0 account-margin">
                      <h3 className="text-primary">Enter your New Relic credentials</h3>
                      <div className="p-2">
                        <Form
                          className="form-horizontal"
                          onSubmit={(e) => {
                            e.preventDefault();
                            validation_nr.handleSubmit();
                            return false;
                          }}
                        >
                          {error ? <Alert color="danger">{error}</Alert> : null}

                          <div className="mb-3">
                            <Label className="form-label">NR Account ID</Label>
                            <Input
                              name="account_id"
                              className="form-control"
                              placeholder="NR Account ID"
                              type="string"
                              onChange={validation_nr.handleChange}
                              onBlur={validation_nr.handleBlur}
                              value={validation_nr.values.account_id || ""}
                              invalid={
                                validation_nr.touched.account_id && validation_nr.errors.account_id ? true : false
                              }
                            />
                            {validation_nr.touched.account_id && validation_nr.errors.account_id ? (
                              <FormFeedback type="invalid">{validation_nr.errors.account_id}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label className="form-label">NR Key</Label>
                            <Input
                              name="api_key"
                              className="form-control"
                              placeholder="NR Key"
                              type="string"
                              onChange={validation_nr.handleChange}
                              onBlur={validation_nr.handleBlur}
                              value={validation_nr.values.api_key || ""}
                              invalid={
                                validation_nr.touched.api_key && validation_nr.errors.api_key ? true : false
                              }
                            />
                            {validation_nr.touched.api_key && validation_nr.errors.api_key ? (
                              <FormFeedback type="invalid">{validation_nr.errors.api_key}</FormFeedback>
                            ) : null}
                          </div>
                          <div className="mt-4">
                            {
                              lastStep ?
                                <button className="btn btn-primary login-button">
                                  Saving...
                                </button> :
                                //startLoading() :
                                <button
                                  className="btn btn-primary login-button"
                                  type="submit"
                                >
                                  Save
                                </button>
                            }

                          </div>
                        </Form>
                      </div>
                    </CardBody>
                  </Card>}

              </Col>
            </Row> : null
          }

          {currentService === 'Grafana' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate Grafana</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipGrafana"><i
                        className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipGrafana}
                      targetId={'tooltipGrafana'}
                      toggle={() => setTooltipGrafana(!tooltipGrafana)}
                      content={'Instructions to integrate '}
                      linkText={'Grafana'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-newrelic-integration'}
                    />
                  </div>
                  <h5>Login to Grafana Cloud and follow these steps</h5>
                </div>
                <div className="mt-4 mb-5">
                  <ol>
                    <li>Enter Controller URL
                      <ul>
                        <li>This can be found in your Grafana Cloud URL</li>
                        <li>Format: <strong><code>"https://[your-instance].grafana.net"</code></strong></li>
                        <li>The <b className="font-size-12">'your_instance'</b> part is the one you need to copy and paste under Grafana Controller URL</li>
                      </ul>
                    </li>
                    <li>Navigate to Administration {'>'} Users and access {'>'} Service accounts {'>'} Add service account</li>
                    <li>Give a display name of your choosing</li>
                    <li>Now, add the following roles from the list given below</li>
                    <ul>
                      <li>Alerting : Access to alert rules provisioning API</li>
                      <li>Alerting : Read via Provisioning API + Export Secrets</li>
                      <li>Data sources : Reader</li>
                      <li>Folders : Writer</li>
                    </ul>

                    <li>Click on 'Add Service Account token'</li>
                    <li>Type a suitable name for this key and set expiration if required</li>
                    <li>Click on "Create a key" and copy the token and paste it as Grafana Service Token</li>
                  </ol>
                </div>
              </Col>

              <Col lg="1">
              </Col>

              <Col lg="5">
                <Card className="overflow-hidden" lg="5">
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your Grafana credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_grafana.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">Grafana Controller URL</Label>
                          <Input
                            name="controller_url"
                            className="form-control"
                            placeholder="Grafana Controller URL"
                            type="string"
                            onChange={validation_grafana.handleChange}
                            onBlur={validation_grafana.handleBlur}
                            value={validation_grafana.values.controller_url || ""}
                            invalid={
                              validation_grafana.touched.controller_url && validation_grafana.errors.controller_url ? true : false
                            }
                          />
                          {validation_grafana.touched.controller_url && validation_grafana.errors.controller_url ? (
                            <FormFeedback type="invalid">{validation_grafana.errors.controller_url}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Grafana Service Token</Label>
                          <Input
                            name="service_token"
                            className="form-control"
                            placeholder="Grafana Service Account token"
                            type="string"
                            onChange={validation_grafana.handleChange}
                            onBlur={validation_grafana.handleBlur}
                            value={validation_grafana.values.service_token || ""}
                            invalid={
                              validation_grafana.touched.service_token && validation_grafana.errors.service_token ? true : false
                            }
                          />
                          {validation_grafana.touched.service_token && validation_grafana.errors.service_token ? (
                            <FormFeedback type="invalid">{validation_grafana.errors.service_token}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mt-4">
                          {
                            lastStep ?
                              <button className="btn btn-primary login-button">
                                Saving...
                              </button> :
                              //startLoading() :
                              <button
                                className="btn btn-primary login-button"
                                type="submit"
                              >
                                Save
                              </button>
                          }

                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }

          {/* This is the Grafana onboarding screen*/}
          {currentService === 'Signoz' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate Signoz</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipSignoz"><i
                        className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipSignoz}
                      targetId={'tooltipSignoz'}
                      toggle={() => setTooltipSignoz(!tooltipSignoz)}
                      content={'Instructions to integrate '}
                      linkText={'Signoz'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-newrelic-integration'}
                    />
                  </div>

                </div>

                <div className="mt-4 mb-5">
                  <ul className="nav nav-tabs card-header-tabs d-flex">
                    <li className="nav-item me-2" style={{
                      width: "25%",
                      borderRadius: "2px",
                      color: "white",
                      background: instructionsTab === "cloud" ? "#3569f3" : "#423b3e7a"
                    }}>
                      <a
                        className={`nav-link text-center ${instructionsTab === "cloud" ? "active" : ""}`}
                        style={{color: "white"}}
                        role="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          setInstructionsTab("cloud");
                        }}
                        aria-controls="cloud"
                        aria-selected={instructionsTab === "cloud"}
                      >
                        Cloud
                      </a>
                    </li>
                    <li className="nav-item" style={{
                      width: "25%",
                      borderRadius: "2px",
                      color: "white",
                      background: instructionsTab === "self-hosted" ? "#3569f3" : "#423b3e7a"
                    }}>
                      <a
                        className={`nav-link text-center ${instructionsTab === "self-hosted" ? "active" : ""}`}
                        role="tab"
                        style={{color: "white"}}
                        onClick={(e) => {
                          e.preventDefault();
                          setInstructionsTab("self-hosted");
                        }}
                        aria-controls="self-hosted"
                        aria-selected={instructionsTab === "self-hosted"}
                      >
                        Self-hosted
                      </a>
                    </li>
                  </ul>

                  <div className="tab-content mt-3">
                    <div className={`tab-pane fade ${instructionsTab === 'cloud' ? 'show active' : ''}`}
                         id="cloud" role="tabpanel">
                      <h5>Login to Signoz Cloud and follow these steps</h5>
                      <ol>
                        <li>Enter Controller URL
                          <ul>
                            <li>This can be found in your Signoz Cloud URL</li>
                            <li>Format: <strong><code>https://[your-instance].in.signoz.cloud</code></strong></li>
                            <li>The <b className="font-size-12">'your_instance'</b> part is the one you need to copy and
                              paste under Signoz Controller URL
                            </li>
                          </ul>
                        </li>
                        <li>Navigate to Invite Team Member {'>'} Users and access {'>'} API Keys</li>
                        <li>Click on + New Key</li>
                        <li>Now, enter a key name and give the permission as <b>Editor</b></li>
                        <li>Click on "Create new key" and copy the token and paste it as Signoz Service Token</li>
                      </ol>
                    </div>

                    <div className={`tab-pane fade ${instructionsTab === 'self-hosted' ? 'show active' : ''}`}
                         id="self-hosted" role="tabpanel">
                      <h5>Login to your Signoz Self Hosted instance and follow these instructions</h5>
                      <ol>
                        <li>Before you login, right click on the screen in the sign in page and then click on Inspect
                          and head to the Network tab
                        </li>
                        <li>Find and click on the login API, then click on the response tab</li>
                        <li>Now, copy the <b>refreshJwt</b> token without the <code>" "</code> and paste it under the Signoz Refresh token</li>
                        <li>Enter Controller URL
                          <ul>
                            <li>Double click on your url as you login</li>
                            <li>Format: <strong><code>https://[your-instance]/home</code></strong></li>
                            <li>The <b className="font-size-12">'your_instance'</b> part is what you need to copy and
                              paste under Signoz Controller URL
                            </li>
                          </ul>
                        </li>

                      </ol>
                    </div>
                  </div>
                </div>

              </Col>

              <Col lg="1">
              </Col>

              <Col lg="5">
                <Card className="overflow-hidden" lg="5">
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your Signoz credentials</h3>

                    <div className="deployment-type-tabs mb-3">
                      <ul className="nav nav-tabs card-header-tabs d-flex w-50">
                        <li className="nav-item flex-fill me-2" style={{
                          borderRadius: "2px",
                          background: deploymentType === "cloud" ? "#3569f3" : "#423b3e7a"
                        }}>
                          <button
                            className={`nav-link w-100 ${deploymentType === 'cloud' ? 'active' : ''}`}
                            style={{color: "white"}}
                            type="button"
                            onClick={() => setDeploymentType('cloud')}
                          >
                            Cloud
                          </button>
                        </li>
                        <li className="nav-item flex-fill" style={{
                          borderRadius: "2px",
                          background: deploymentType === "self-hosted" ? "#3569f3" : "#423b3e7a"
                        }}>
                          <button
                            className={`nav-link w-100 ${deploymentType === 'self-hosted' ? 'active' : ''}`}
                            style={{color: "white"}}
                            type="button"
                            onClick={() => setDeploymentType('self-hosted')}
                          >
                            Self-hosted
                          </button>
                        </li>
                      </ul>
                    </div>

                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_signoz.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">Signoz Controller URL</Label>
                          <Input
                            name="controller_url"
                            className="form-control"
                            placeholder="Signoz Controller URL"
                            type="string"
                            onChange={validation_signoz.handleChange}
                            onBlur={validation_signoz.handleBlur}
                            value={validation_signoz.values.controller_url || ""}
                            invalid={
                              validation_signoz.touched.controller_url && validation_signoz.errors.controller_url ? true : false
                            }
                          />
                          {validation_signoz.touched.controller_url && validation_signoz.errors.controller_url ? (
                            <FormFeedback type="invalid">{validation_signoz.errors.controller_url}</FormFeedback>
                          ) : null}
                        </div>

                        {deploymentType === 'cloud' && (
                          <div className="mb-3">
                            <Label className="form-label">Signoz Service Token</Label>
                            <Input
                              name="service_token"
                              className="form-control"
                              placeholder="Signoz Service Account token"
                              type="string"
                              onChange={validation_signoz.handleChange}
                              onBlur={validation_signoz.handleBlur}
                              value={validation_signoz.values.service_token || ""}
                              invalid={
                                validation_signoz.touched.service_token && validation_signoz.errors.service_token ? true : false
                              }
                            />
                            {validation_signoz.touched.service_token && validation_signoz.errors.service_token ? (
                              <FormFeedback type="invalid">{validation_signoz.errors.service_token}</FormFeedback>
                            ) : null}
                          </div>
                        )}

                        {deploymentType === 'self-hosted' && (
                          <div className="mb-3">
                            <Label className="form-label">Signoz Refresh Token</Label>
                            <Input
                              name="refresh_token"
                              className="form-control"
                              placeholder="Signoz Refresh Jwt Token"
                              type="string"
                              onChange={validation_signoz.handleChange}
                              onBlur={validation_signoz.handleBlur}
                              value={validation_signoz.values.refresh_token || ""}
                              invalid={
                                validation_signoz.touched.refresh_token && validation_signoz.errors.refresh_token ? true : false
                              }
                            />
                            {validation_signoz.touched.refresh_token && validation_signoz.errors.refresh_token ? (
                              <FormFeedback type="invalid">{validation_signoz.errors.refresh_token}</FormFeedback>
                            ) : null}
                          </div>
                        )}

                        <div style={{display: "flex", alignItems: "center", marginTop: "20px"}}>
                          {isSignozVerifying ? (
                            <div>
                              <Spinner className="ms-2" color="primary"/>
                            </div>
                          ) : !isSignozVerified ? (
                              <div style={{display: "flex", alignItems: "center"}}>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={handleVerificationSignoz}
                                >
                                  Test Connection
                                </button>
                                <span
                                  id="TooltipRight"
                                  onMouseOver={() => settright(true)}
                                  onMouseLeave={() => settright(false)}
                                  className="alert-icon"
                                  style={{marginLeft: "10px", display: "inline-flex", alignItems: "center"}}
                                >
                                    <i className="mdi mdi-information-outline text-warning"/>
                                    <Tooltip
                                      placement="top"
                                      isOpen={tright}
                                      target="TooltipRight"
                                      toggle={() => settright(!tright)}
                                      style={{
                                        border: "2px solid #f1b44c",
                                        borderRadius: "10px",
                                        backgroundColor: "#2a3042",
                                        zIndex: 1,
                                      }}
                                    >
                                      We will verify your credentials to access services from your signoz account.
                                    </Tooltip>
                                  </span>
                              </div>
                            )
                            : (
                              <div style={{alignContent: "center", display: "flex", justifyContent: "space-between"}}>
                                <div className='text-success' color="success">Verified</div>
                                <i className="mdi mdi-check-circle text-success" style={{marginLeft: "5px"}}/>
                              </div>
                            )}
                        </div>

                        <div className="mt-4">
                          {lastStep ? (
                            <button className="btn btn-primary login-button">
                              Saving...
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary login-button"
                              type="submit"
                            >
                              Save
                            </button>
                          )}
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }
          {/* This is the Datadog onboarding screen*/}

          {currentService === 'Datadog' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate Datadog</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipDatadog"><i
                        className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipDatadog}
                      targetId={'tooltipDatadog'}
                      toggle={() => setTooltipDatadog(!tooltipDatadog)}
                      content={'Instructions to integrate '}
                      linkText={'Datadog'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-datadog-integration'}
                    />
                  </div>
                  <h5>Login to Datadog and follow these steps</h5>
                </div>
                <div className="mt-4 mb-5">
                  <ol>
                    <li>Navigate to Profile{'>'}Organization Settings {'>'} API Keys</li>
                    <li>Click on "+ New Key"</li>
                    <li>Enter a Name</li>
                    <li>Select Create Key and copy the key</li>
                    <li>Then in the Organization Settings {'>'} Application Keys</li>
                    <li>Click on "+ New Key"</li>
                    <li>Enter a Name</li>
                    <li>Select Create Key</li>
                    <li>Copy the key</li>
                    <li>Choose your Datadog site. You can find that during datadog login or by looking at your url. Valid options are
                      us1, us3, us5, ap1, eu, and us1-fed
                    </li>
                  </ol>
                </div>
              </Col>

              <Col lg="1">
              </Col>

              <Col lg="5">
                <Card className="" lg="5">
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your Datadog credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_dd.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">Datadog API Key</Label>
                          <Input
                            name="api_key"
                            className="form-control"
                            placeholder="Datadog API Key"
                            type="string"
                            onChange={validation_dd.handleChange}
                            onBlur={validation_dd.handleBlur}
                            value={validation_dd.values.api_key || ""}
                            invalid={
                              validation_dd.touched.api_key && validation_dd.errors.api_key ? true : false
                            }
                          />
                          {validation_dd.touched.api_key && validation_dd.errors.api_key ? (
                            <FormFeedback type="invalid">{validation_dd.errors.api_key}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Datadog Application Key</Label>
                          <Input
                            name="application_key"
                            className="form-control"
                            placeholder="Datadog Application Key"
                            type="string"
                            onChange={validation_dd.handleChange}
                            onBlur={validation_dd.handleBlur}
                            value={validation_dd.values.application_key || ""}
                            invalid={
                              validation_dd.touched.application_key && validation_dd.errors.application_key ? true : false
                            }
                          />
                          {validation_dd.touched.application_key && validation_dd.errors.application_key ? (
                            <FormFeedback type="invalid">{validation_dd.errors.application_key}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Datadog Site</Label>
                          <Select
                            value={selectedDatadogSite}
                            onChange={(selectedValue) => {
                              setSelectedDatadogSite(selectedValue);
                            }}
                            options={dataDogSiteOptionGroup}
                            className="select2-selection"
                            required
                            // styles={{
                            //   menu: provided => ({ ...provided, zIndex: 9999 })
                            // }}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 0,
                              colors: {
                                ...theme.colors,
                                neutral0: '#222736',
                                neutral5: '#485EC4',
                                neutral10: '#485EC4',
                                neutral60: '#ffffff',
                                neutral70: '#ffffff',
                                neutral80: '#ffffff',
                                neutral90: '#ffffff',
                                primary: '#485EC4',
                              },
                            })}
                            styles={customStyles}
                          />
                          {validation_dd.touched.site && validation_dd.errors.site ? (
                            <FormFeedback type="invalid">{validation_dd.errors.site}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mt-4">
                          {
                            lastStep ?
                              <button className="btn btn-primary login-button">
                                Saving...
                              </button> :
                              //startLoading() :
                              <button
                                className="btn btn-primary login-button"
                                type="submit"
                              >
                                Save
                              </button>
                          }

                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }

          {/* This is the Splunk onboarding screen*/}
          {currentService === 'Splunk' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate Splunk</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipSplunk"><i
                        className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipSplunk}
                      targetId={'tooltipSplunk'}
                      toggle={() => setTooltipSplunk(!tooltipSplunk)}
                      content={'Instructions to integrate '}
                      linkText={'Splunk'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-splunk-integration'}
                    />
                  </div>
                  <h5>Login to Splunk and follow these steps</h5>
                </div>
                <div className="mt-4 mb-5">
                  <ol>
                    <li>Navigate to Settings {'>'} Profile {'>'} Show User API Access Token</li>
                    <li>Copy the token and enter in API Key</li>
                    <li>Enter your Splunk realm. You can find that during Splunk login or by looking at your url.
                      In the url it is as app.{'{'}realm{'}'}.signalfx.com. Eg. of realms are us1, us0, eu0, etc
                    </li>
                  </ol>
                </div>
              </Col>

              <Col lg="1">
              </Col>

              <Col lg="5">
                <Card className="" lg="5">
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your Splunk credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_splunk.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">Splunk API Key</Label>
                          <Input
                            name="api_key"
                            className="form-control"
                            placeholder="Splunk API Key"
                            type="string"
                            onChange={validation_splunk.handleChange}
                            onBlur={validation_splunk.handleBlur}
                            value={validation_splunk.values.api_key || ""}
                            invalid={
                              validation_splunk.touched.api_key && validation_splunk.errors.api_key ? true : false
                            }
                          />
                          {validation_splunk.touched.api_key && validation_splunk.errors.api_key ? (
                            <FormFeedback type="invalid">{validation_splunk.errors.api_key}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Splunk Realm</Label>
                          <Input
                            name="realm"
                            className="form-control"
                            placeholder="Splunk Realm"
                            type="string"
                            onChange={validation_splunk.handleChange}
                            onBlur={validation_splunk.handleBlur}
                            value={validation_splunk.values.realm || ""}
                            invalid={
                              validation_splunk.touched.realm && validation_splunk.errors.realm ? true : false
                            }
                          />
                          {validation_splunk.touched.realm && validation_splunk.errors.realm ? (
                            <FormFeedback type="invalid">{validation_splunk.errors.realm}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Splunk Environments</Label>
                          <Input
                            name="splunk_environments"
                            value={validation_splunk.values.splunk_environments || ""}
                            type="text"
                            placeholder="Enter Splunk Environments(comma(,) separated for multiple environments)"
                            onChange={e => validation_splunk.setFieldValue('splunk_environments', e.target.value)}
                            onBlur={validation_splunk.handleBlur}
                            invalid={
                              validation_splunk.touched.splunk_environments && validation_splunk.errors.splunk_environments ? true : false
                            }
                          />
                          {validation_splunk.touched.splunk_environments && validation_splunk.errors.splunk_environments ? (
                            <FormFeedback type="invalid">{validation_splunk.errors.splunk_environments}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mt-4">
                          {
                            lastStep ?
                              <button className="btn btn-primary login-button">
                                Saving...
                              </button> :
                              //startLoading() :
                              <button
                                className="btn btn-primary login-button"
                                type="submit"
                              >
                                Save
                              </button>
                          }

                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }

          {/* This is the OpsGenie onboarding screen*/}

          {currentService === 'OpsGenie' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate OpsGenie</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipOG"><i className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipOG}
                      targetId={'tooltipOG'}
                      toggle={() => setTooltipOG(!tooltipOG)}
                      content={'Instructions to integrate '}
                      linkText={'OpsGenie'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/external-notifications/integration-of-opsgenie'}
                    />
                  </div>
                  <h5>Login to OpsGenie and follow these steps</h5>
                </div>
                <div className="mt-4 mb-5">
                  <ol>
                    <li>Navigate to Settings{' > '}App Settings{' > '}API key management</li>
                    <li>Click on "Add new API key"</li>
                    <li>Enter a suitable name for the key</li>
                    <li>Under Access rights, select "Read", "Create and update", and "Configuration access"</li>
                    <li>Click on "Add API key"</li>
                    <li>Copy the API key and use it here</li>
                  </ol>
                </div>
              </Col>

              <Col lg="1">
              </Col>

              <Col lg="5">
                <Card className="overflow-hidden" lg="5">
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your OpsGenie credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_opsgenie.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">OpsGenie Key</Label>
                          <Input
                            name="opsgenie_api_key"
                            className="form-control"
                            placeholder="OpsGenie Key"
                            type="string"
                            onChange={validation_opsgenie.handleChange}
                            onBlur={validation_opsgenie.handleBlur}
                            value={validation_opsgenie.values.opsgenie_api_key || ""}
                            invalid={
                              validation_opsgenie.touched.opsgenie_api_key && validation_opsgenie.errors.opsgenie_api_key ? true : false
                            }
                          />
                          {validation_opsgenie.touched.opsgenie_api_key && validation_opsgenie.errors.opsgenie_api_key ? (
                            <FormFeedback type="invalid">{validation_opsgenie.errors.opsgenie_api_key}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mt-4">
                          {
                            lastStep ?
                              <button className="btn btn-primary login-button">
                                Saving...
                              </button> :
                              //startLoading() :
                              <button
                                className="btn btn-primary login-button"
                                type="submit"
                              >
                                Save
                              </button>
                          }
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }

          {/* This is the PagerDuty onboarding screen*/}

          {currentService === 'PagerDuty' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate PagerDuty</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipPagerduty"><i
                        className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipPagerDuty}
                      targetId={'tooltipPagerduty'}
                      toggle={() => setTooltipPagerduty(!tooltipPagerDuty)}
                      content={'Instructions to integrate '}
                      linkText={'PagerDuty'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/external-notifications/integration-of-pagerduty'}
                    />
                  </div>
                  <h5>Login to PagerDuty and follow these steps</h5>
                </div>
                <div className="mt-4 mb-5">
                  <ol>
                    <li>Navigate to Integrations{' > '}API Access keys</li>
                    <li>Click on "Create new API key"</li>
                    <li>Enter a suitable description</li>
                    <li>Leave the "Read-only API Key" checkbox UNCHECKED</li>
                    <li>Click on "Create Key"</li>
                    <li>Copy the API key and use it here</li>
                  </ol>
                </div>
              </Col>

              <Col lg="1">
              </Col>

              <Col lg="5">
                <Card className="overflow-hidden" lg="5">
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your PagerDuty credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_pagerduty.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">PagerDuty Key</Label>
                          <Input
                            name="pagerduty_api_key"
                            className="form-control"
                            placeholder="PagerDuty Key"
                            type="string"
                            onChange={validation_pagerduty.handleChange}
                            onBlur={validation_pagerduty.handleBlur}
                            value={validation_pagerduty.values.pagerduty_api_key || ""}
                            invalid={
                              validation_pagerduty.touched.pagerduty_api_key && validation_pagerduty.errors.pagerduty_api_key ? true : false
                            }
                          />
                          {validation_pagerduty.touched.pagerduty_api_key && validation_pagerduty.errors.pagerduty_api_key ? (
                            <FormFeedback type="invalid">{validation_pagerduty.errors.pagerduty_api_key}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mt-4">
                          {
                            lastStep ?
                              <button className="btn btn-primary login-button">
                                Saving...
                              </button> :
                              //startLoading() :
                              <button className="btn btn-primary login-button" type="submit">
                                Save
                              </button>
                          }
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }

          {/* This is the Oracle Cloud Infrastructure onboarding screen*/}
          {currentService === 'Oracle Cloud Infrastructure' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate Oracle Cloud Infrastructure</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipSplunk"><i
                        className="bx bx-help-circle font-size-20 text-white mb-1"/></span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipOci}
                      targetId={'tooltipSplunk'}
                      toggle={() => setTooltipOci(!tooltipOci)}
                      content={'Instructions to integrate '}
                      linkText={'Oci'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-oci-integration'}
                    />
                  </div>
                  <h5>To onboard OCI, follow these steps</h5>
                </div>
                <div className="mt-4 mb-5">
                  <h5>Step 1: Create Domain</h5>
                  <ol>
                    <li>Login to OCI, Open Navigation Menu, then Goto <strong>Identity &
                      Security</strong> -> <strong>Overview</strong> -> <strong>Domain</strong></li>
                    <li>
                      Click on "Create Domain" and follow these steps:
                      <ul>
                        <li>Provide an appropriate <strong>Name</strong> and <strong>Description</strong>.</li>
                        <li>Select <strong>Domain Type</strong> as "Free".</li>
                        <li>Ensure to uncheck <strong>Create an administrative user for this domain</strong>.</li>
                        <li>Choose the root compartment of your tenancy as the <strong>Compartment</strong>.</li>
                        <li>Ensure to select the <strong>Compartment</strong> as your <strong>Root Compartment</strong></li>
                        <li>Click on <strong>Create Domain</strong> to create the domain.</li>
                      </ul>
                    </li>
                    <li>Copy the name of the domain, this will be used in a later step</li>

                  </ol>

                  <h5>Step 2: Configure Domain Settings</h5>
                  <ol>
                    <li>Open the newly created domain and goto <strong>Settings</strong></li>
                    <li>
                      Under <strong>Domain Settings</strong> -> <strong>User Settings</strong>, uncheck
                      <strong>Primary email address required</strong>.
                    </li>
                    <li><strong>Save Changes</strong>.</li>
                    <li>If your resources are distributed across multiple regions, ensure that
                      <strong>Domain Replication</strong> is enabled.
                      <ol>
                        <li>Navigate the main menu of the created domain</li>
                        <li>Under <strong>More Actions</strong>, select <strong>Manage Regions</strong>.</li>
                        <li>Enable replication for all regions where your resources are located by clicking
                          <strong>Enable Replication</strong>.
                        </li>
                        <li>Wait for the replication process to complete before proceeding to the next steps.</li>
                      </ol>
                    </li>
                  </ol>

                  <h5>Step 3: Create User and Group</h5>
                  <ol>
                    <li>Go back to the newly created domain. And goto <strong>Users</strong>.</li>
                    <li>
                      <strong>Create User</strong>:
                      <ul>
                        <li>Enter an appropriate <strong>Last Name</strong>.</li>
                        <li>Uncheck <strong>Use the email address as the username</strong>.</li>
                        <li>Enter an appropriate <strong>Username</strong>.</li>
                        <li>Ensure to select the <strong>Compartment</strong> as your <strong>Root
                          Compartment</strong></li>
                        <li>Click on <strong>Create</strong> to create the user.</li>
                      </ul>
                    </li>
                    <li>Go back to the created domain.</li>
                    <li>Goto <strong>Groups</strong> -> <strong>Create Group</strong>:
                      <ul>
                        <li>Enter <strong>Name</strong> and <strong>Description</strong> for the group.</li>
                        <li>Use the <strong>Users</strong> option to assign the user created in the last step to the
                          group.
                        </li>
                        <li>Ensure to select the <strong>Compartment</strong> as your <strong>Root
                          Compartment</strong></li>
                        <li>Click on <strong>Create</strong> to create the group.</li>
                      </ul>
                    </li>
                    <li>Copy the <strong>Name</strong></li>
                  </ol>

                  <h5>Step 4: Create Policy</h5>
                  <ol>
                    <li>Go back to <strong>Domains</strong>.</li>
                    <li>Goto <strong>Policies</strong> -> <strong>Create Policy</strong>:
                      <ul>
                        <li>Enter a <strong>Name</strong> and <strong>Description</strong>.</li>
                        <li>Toggle the <strong>Show Manual Editor</strong>.</li>
                        <li>Copy and paste the following policy in the editor:
                          <div style={{
                            padding: '10px 5px',
                            background: 'rgba(23,23,23,0.45)',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}>
                            <code
                              className="code-snippet"
                              style={{
                                fontSize: 'normal',
                                padding: '5px',
                              }}
                            >Allow group '&lt;domain_name&gt;'/'&lt;group_name&gt;' to read all-resources in
                              tenancy<br/>
                              Allow group '&lt;domain_name&gt;'/'&lt;group_name&gt;' to read metrics in tenancy<br/>
                              Allow group '&lt;domain_name&gt;'/'&lt;group_name&gt;' to manage alarms in tenancy<br/>
                              Allow group '&lt;domain_name&gt;'/'&lt;group_name&gt;' to manage ons-topics in
                              tenancy<br/>
                              Allow group '&lt;domain_name&gt;'/'&lt;group_name&gt;' to manage ons-subscriptions in
                              tenancy</code>
                            <i className="bx bx-copy-alt" style={{
                              textAlign: 'center',
                              verticalAlign: 'middle',
                              fontSize: 'normal',
                              cursor: 'pointer',
                              width: '15px',
                              height: '15px'
                            }} onClick={() => {
                              copyToClipboard("Allow group '<domain_name>'/'<group_name>' to read all-resources in tenancy\nAllow group '<domain_name>'/'<group_name>' to read metrics in tenancy\nAllow group '<domain_name>'/'<group_name>' to manage alarms in tenancy\nAllow group '<domain_name>'/'<group_name>' to manage ons-topics in tenancy\nAllow group '<domain_name>'/'<group_name>' to manage ons-subscriptions in tenancy")
                            }}></i>
                          </div>
                        </li>
                        <li>Replace <code>&lt;domain_name&gt;</code> with the domain name that you created.</li>
                        <li>Replace <code>&lt;group_name&gt;</code> with the group name that you created.</li>
                        <li>Ensure to select the <strong>Compartment</strong> as your <strong>Root
                          Compartment</strong></li>
                        <li>Click on Create to create the policy</li>
                      </ul>
                    </li>
                  </ol>

                  <h5>Step 5: Add API Key</h5>
                  <ol>
                    <li>Go to <strong>Domains</strong> -> <strong>Created Domain</strong> -> <strong>Users</strong>, open the created user.</li>
                    <li>
                      Go to <strong>API Keys</strong> -> <strong>Add API Key</strong>:
                      <ul>
                        <li>
                          Generate the API key pair and download the private key.
                          <ul>
                            <li>
                              For Windows:
                              <ol>
                                <li>Navigate to the downloaded file using Windows Explorer.</li>
                                <li>Press <strong>Alt + Enter</strong> to open the properties.</li>
                                <li>Under attributes, ensure to check <strong>Read-only</strong>.</li>
                                <li>Click on <strong>Apply</strong>, then click on <strong>Ok</strong>, and then close the popup</li>
                              </ol>
                            </li>
                            <li>
                              For Linux/Mac OS:
                              <ol>
                                <li>Open a terminal and navigate to the downloaded file.</li>
                                <li>Run the following command:
                                  <div style={{
                                    padding: '10px 5px',
                                    background: 'rgba(23,23,23,0.45)',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                  }}>
                                    <code
                                      className="code-snippet"
                                      style={{
                                        fontSize: 'normal',
                                        padding: '5px'
                                      }}
                                    >chmod 400 &lt;name_of_your_private_key_file&gt;</code>
                                    <i className="bx bx-copy-alt" style={{
                                      textAlign: 'center',
                                      verticalAlign: 'middle',
                                      fontSize: 'normal',
                                      cursor: 'pointer',
                                      width: '15px',
                                      height: '15px'
                                    }} onClick={() => {
                                      copyToClipboard("chmod 400 <name_of_your_private_key_file>")
                                    }}></i>
                                  </div>
                                </li>
                                <li>Ensure to replace <code>&lt;name_of_your_private_key_file&gt;</code> with the name of your private key file, downloaded
                                  from the above step
                                </li>
                              </ol>
                            </li>

                          </ul>
                        </li>
                        <li>Click on add, to generate and save the credentials</li>
                      </ul>
                    </li>
                    <li>
                      From the <strong>Preview Configuration File</strong> popup, copy:
                      <ul>
                        <li>User OCID</li>
                        <li>Fingerprint for the API key</li>
                        <li>Tenancy OCID</li>
                      </ul>
                    </li>
                    <li>Open the private key file in a text editor, copy its contents, and paste them in the designated field.
                      <ul>
                        <li>For Windows
                          <ol>
                            <li>Navigate to the downloaded key file</li>
                            <li>Open the file using <strong>Notepad</strong></li>
                            <li>Select everything starting from <code>-----BEGIN PRIVATE KEY-----</code>, continue until the line <code>OCI_API_KEY</code> is
                              fully included.
                            </li>
                            <li>Ensure no extra spaces, newlines, or characters are added.</li>
                          </ol>
                        </li>
                        <li>For Linux/Macos
                          <ol>
                            <li>Open a terminal and navigate to the downloaded file.</li>
                            <li>Run the following command:
                              <div style={{
                                padding: '10px 5px',
                                background: 'rgba(23,23,23,0.45)',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}>
                                <code
                                  className="code-snippet"
                                  style={{
                                    fontSize: 'normal',
                                    padding: '5px'
                                  }}
                                >cat &lt;name_of_your_private_key_file&gt;</code>
                                <i className="bx bx-copy-alt" style={{
                                  textAlign: 'center',
                                  verticalAlign: 'middle',
                                  fontSize: 'normal',
                                  cursor: 'pointer',
                                  width: '15px',
                                  height: '15px'
                                }} onClick={() => {
                                  copyToClipboard("cat <name_of_your_private_key_file>")
                                }}></i>
                              </div>
                            </li>
                            <li>Ensure to replace <code>&lt;name_of_your_private_key_file&gt;</code> with the name of your private key file, downloaded from
                              the above step
                            </li>
                            <li>Select everything starting from <code>-----BEGIN PRIVATE KEY-----</code>, continue until the line <code>OCI_API_KEY</code> is
                              fully included.
                            </li>
                            <li>Ensure no extra spaces, newlines, or characters are added.</li>
                          </ol>
                        </li>
                      </ul>
                    </li>
                  </ol>

                  <h5>Step 6: Create compartment for TemperstackNotification</h5>
                  <ol>
                    <li>Open Navigation Menu, then Goto <strong>Identity & Security</strong> -> <strong>Compartments</strong></li>
                    <li>Click on <strong>Create Compartment</strong></li>
                    <li>Give an appropiate name, and description</li>
                    <li>Under <strong>Parent Compartment</strong>, select the <strong>Root Compartment</strong></li>
                    <li>Click on <strong>Create Compartment</strong></li>
                    <li>Click on the created compartment</li>
                    <li>Under OCID, Click on <strong>Copy</strong></li>
                    <li>Paste it under the field, <strong>Temperstack Compartment OCID</strong></li>
                  </ol>
                </div>
              </Col>

              <Col lg="1">
              </Col>

              <Col lg="5">
                <Card className="" lg="5">
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your OCI credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_oci.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">OCI Region</Label>
                          <Multiselect
                            name="oci_region"
                            options={oci_region_options}
                            placeholder="Select all that apply"
                            displayValue="name"
                            closeOnSelect={false}
                            onSelect={(selectedList, selectedItem) => handleOCIRegionUpdate(selectedList)}
                            onRemove={(selectedList, removedItem) => handleOCIRegionUpdate(selectedList)}
                            selectedValues={OCIRegion || ""}
                            className="multiselect select2-selection mb-3"
                            style={{optionContainer: {backgroundColor: "#382b42"}}}
                          />
                          <Label className="form-label">OCI User Id</Label>
                          <Input
                            name="user_id"
                            className="form-control"
                            placeholder="OCI User Id"
                            type="string"
                            onChange={validation_oci.handleChange}
                            onBlur={validation_oci.handleBlur}
                            value={validation_oci.values.user_id || ""}
                            invalid={
                              validation_oci.touched.user_id && validation_oci.errors.user_id ? true : false
                            }
                          />
                          {validation_oci.touched.user_id && validation_oci.errors.user_id ? (
                            <FormFeedback type="invalid">{validation_oci.errors.user_id}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">OCI Fingerprint</Label>
                          <Input
                            name="fingerprint"
                            className="form-control"
                            placeholder="OCI Fingerprint"
                            type="string"
                            onChange={validation_oci.handleChange}
                            onBlur={validation_oci.handleBlur}
                            value={validation_oci.values.fingerprint || ""}
                            invalid={
                              validation_oci.touched.fingerprint && validation_oci.errors.fingerprint ? true : false
                            }
                          />
                          {validation_oci.touched.fingerprint && validation_oci.errors.fingerprint ? (
                            <FormFeedback type="invalid">{validation_oci.errors.fingerprint}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">OCI Tenancy Id</Label>
                          <Input
                            name="tenancy_id"
                            className="form-control"
                            placeholder="OCI Tenancy Id"
                            type="string"
                            onChange={validation_oci.handleChange}
                            onBlur={validation_oci.handleBlur}
                            value={validation_oci.values.tenancy_id || ""}
                            invalid={
                              validation_oci.touched.tenancy_id && validation_oci.errors.tenancy_id ? true : false
                            }
                          />
                          {validation_oci.touched.tenancy_id && validation_oci.errors.tenancy_id ? (
                            <FormFeedback type="invalid">{validation_oci.errors.tenancy_id}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">OCI Key content</Label>
                          <Input
                            name="key_content"
                            className="form-control"
                            placeholder="OCI Key content"
                            type="textarea"
                            style={{
                              height: 150,
                              fontFamily: "monospace"
                            }}
                            onChange={validation_oci.handleChange}
                            onBlur={validation_oci.handleBlur}
                            value={validation_oci.values.key_content || ""}
                            invalid={
                              validation_oci.touched.key_content && validation_oci.errors.key_content ? true : false
                            }
                          />
                          {validation_oci.touched.key_content && validation_oci.errors.key_content ? (
                            <FormFeedback type="invalid">{validation_oci.errors.key_content}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Temperstack Compartment OCID</Label>
                          <Input
                            name="temperstack_ocid"
                            className="form-control"
                            placeholder="Temperstack OCID"
                            type="string"
                            onChange={validation_oci.handleChange}
                            onBlur={validation_oci.handleBlur}
                            value={validation_oci.values.temperstack_ocid || ""}
                            invalid={
                              validation_oci.touched.temperstack_ocid && validation_oci.errors.temperstack_ocid ? true : false
                            }
                          />
                          {validation_oci.touched.temperstack_ocid && validation_oci.errors.temperstack_ocid ? (
                            <FormFeedback type="invalid">{validation_oci.errors.temperstack_ocid}</FormFeedback>
                          ) : null}
                        </div>
                        {!isOCIVerified ? (
                          isOCIVerifying ? (
                            <div>
                              <Spinner className="ms-2" color="primary"/>
                            </div>
                          ) : (
                            <div style={{display: "flex", alignItems: "center"}}>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleVerificationOCI}
                              >
                                Test Connection
                              </button>
                              <span
                                id="TooltipRight"
                                onMouseOver={() => settright(true)}
                                onMouseLeave={() => settright(false)}
                                className="alert-icon"
                                style={{marginLeft: "10px", display: "inline-flex", alignItems: "center"}}
                              >
                                    <i className="mdi mdi-information-outline text-warning"/>
                                    <Tooltip
                                      placement="top"
                                      isOpen={tright}
                                      target="TooltipRight"
                                      toggle={() => settright(!tright)}
                                      style={{
                                        border: "2px solid #f1b44c",
                                        borderRadius: "10px",
                                        backgroundColor: "#2a3042",
                                        zIndex: 1,
                                      }}
                                    >
                                      We will verify your credentials to by fetching the compartment details of your root compartment, ie your tenancy
                                    </Tooltip>
                                  </span>
                            </div>
                          )
                        ) : (
                          <div style={{alignContent: "center", display: "flex", justifyContent: "space-between"}}>
                            <div className='text-success' color="success">Verified</div>
                            <i className="mdi mdi-check-circle text-success" style={{marginLeft: "5px"}}/>
                          </div>
                        )}
                        <div className="mt-4">
                          {
                            lastStep ?
                              <button className="btn btn-primary login-button">
                                Saving...
                              </button> :
                              //startLoading() :
                              <button
                                className="btn btn-primary login-button"
                                type="submit"
                              >
                                Save
                              </button>
                          }

                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }

          {/* This is the Temperstack Synthetics onboarding screen*/}

          {currentService === 'Temperstack' ?
            <Row className="mt-4">
              <Col lg="12">
                <AddPingMonitoring fromIntegrationFlow={true}/>
              </Col>
            </Row> : null
          }
          {currentService === 'Sentry' ?
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate Sentry</h3>
                      <span role="button" style={{marginBottom: "2px"}} id="tooltipSentry">
                      <i className="bx bx-help-circle font-size-20 text-white mb-1"/>
                    </span>
                    </div>
                    <DocsTooltip
                      placement={'right'}
                      isOpen={tooltipSentry}
                      targetId={'tooltipSentry'}
                      toggle={() => setTooltipSentry(!tooltipSentry)}
                      content={'Instructions to integrate '}
                      linkText={'Sentry'}
                      link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/setting-up-sentry-integration'}
                    />
                  </div>
                  <h5>To onboard Sentry, follow below step</h5>
                </div>
                <div className="mt-4 mb-5">
                  <h5>Generate Sentry Auth Token</h5>
                  <ol>
                    <li>Login to your Sentry account</li>
                    <li>Navigate to your profile section on the top left dropdown</li>
                    <li>Choose User Auth Tokens</li>
                    <li>
                      Create a new User Auth Token with the following permissions:
                      <ul>
                        <li>Read permissions for <strong>Project</strong></li>
                        <li>Read permissions for <strong>Issue & Event</strong></li>
                      </ul>
                    </li>
                    <li>Save the generated Auth Token securely as it will be required for integration</li>
                  </ol>
                </div>
              </Col>
              <Col lg="1">
              </Col>
              <Col lg="5">
                <Card>
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your Sentry credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_sentry.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">Sentry Auth Token</Label>
                          <Input
                            name="auth_token"
                            className="form-control"
                            placeholder="Sentry Auth Token"
                            type="password"
                            onChange={validation_sentry.handleChange}
                            onBlur={validation_sentry.handleBlur}
                            value={validation_sentry.values.auth_token || ""}
                            invalid={
                              validation_sentry.touched.auth_token && validation_sentry.errors.auth_token ? true : false
                            }
                          />
                          {validation_sentry.touched.auth_token && validation_sentry.errors.auth_token ? (
                            <FormFeedback type="invalid">{validation_sentry.errors.auth_token}</FormFeedback>
                          ) : null}
                        </div>
                        {!isSentryVerified ? (
                          is_sentry_verifying ? (
                            <div>
                              <Spinner className="ms-2" color="primary"/>
                            </div>
                          ) : (
                            <div style={{display: "flex", alignItems: "center"}}>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleVerificationSentry}
                              >
                                Test Connection
                              </button>
                              <span
                                id="TooltipRight"
                                onMouseOver={() => settright(true)}
                                onMouseLeave={() => settright(false)}
                                className="alert-icon"
                                style={{marginLeft: "10px", display: "inline-flex", alignItems: "center"}}
                              >
                              <i className="mdi mdi-information-outline text-warning"/>
                              <Tooltip
                                placement="top"
                                isOpen={tright}
                                target="TooltipRight"
                                toggle={() => settright(!tright)}
                                style={{
                                  border: "2px solid #f1b44c",
                                  borderRadius: "10px",
                                  backgroundColor: "#2a3042",
                                  zIndex: 1,
                                }}
                              >
                                We will verify your Sentry credentials by attempting to access your Sentry organization data
                              </Tooltip>
                            </span>
                            </div>
                          )
                        ) : (
                          <div style={{alignContent: "center", display: "flex", justifyContent: "space-between"}}>
                            <div className='text-success' color="success">Verified</div>
                            <i className="mdi mdi-check-circle text-success" style={{marginLeft: "5px"}}/>
                          </div>
                        )}
                        <div className="mt-4">
                          {lastStep ? (
                            <button className="btn btn-primary login-button" disabled>
                              Saving...
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary login-button"
                              type="submit"
                              disabled={!isSentryVerified}
                            >
                              Save
                            </button>
                          )}
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> : null
          }
          {currentService === 'Loki' ? (
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate Loki</h3>
                    </div>
                  </div>
                  <h5>Configuration Details Required</h5>
                </div>
                <div className="mt-4 mb-2">
                  <h5>Step 1: Loki Instance URL and Auth Basic Auth credentials</h5>
                  <ol>
                    <li>
                      <strong>Datasource URL</strong>
                      <ul>
                        <li>Provide the complete URL where your Loki instance is running</li>
                        <li>Ensure the URL is fully qualified</li>
                        <li>This URL will be used to establish the connection to your Loki logging system</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Authentication Credentials</strong>
                      <ul>
                        <li>Provide the username for basic authentication</li>
                        <li>Provide the corresponding password for the username</li>
                        <li>These credentials will be used to secure access to your Grafana Logs</li>
                      </ul>
                    </li>
                  </ol>
                </div>
              </Col>
              <Col lg="1">
              </Col>
              <Col lg="5">
                <Card>
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your Loki credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_loki.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">Loki Datasource URL</Label>
                          <Input
                            name="url"
                            className="form-control"
                            placeholder="Loki URL"
                            type="text"
                            onChange={validation_loki.handleChange}
                            onBlur={validation_loki.handleBlur}
                            value={validation_loki.values.url || ""}
                            invalid={
                              validation_loki.touched.url && validation_loki.errors.url ? true : false
                            }
                          />
                          {validation_loki.touched.url && validation_loki.errors.url ? (
                            <FormFeedback type="invalid">{validation_loki.errors.url}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Username</Label>
                          <Input
                            name="username"
                            className="form-control"
                            placeholder="Username"
                            type="text"
                            onChange={validation_loki.handleChange}
                            onBlur={validation_loki.handleBlur}
                            value={validation_loki.values.username || ""}
                            invalid={
                              validation_loki.touched.username && validation_loki.errors.username ? true : false
                            }
                          />
                          {validation_loki.touched.username && validation_loki.errors.username ? (
                            <FormFeedback type="invalid">{validation_loki.errors.username}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Password</Label>
                          <Input
                            name="password"
                            className="form-control"
                            placeholder="Password"
                            type="password"
                            onChange={validation_loki.handleChange}
                            onBlur={validation_loki.handleBlur}
                            value={validation_loki.values.password || ""}
                            invalid={
                              validation_loki.touched.password && validation_loki.errors.password ? true : false
                            }
                          />
                          {validation_loki.touched.password && validation_loki.errors.password ? (
                            <FormFeedback type="invalid">{validation_loki.errors.password}</FormFeedback>
                          ) : null}
                        </div>
                        {!isLokiVerified ? (
                          is_loki_verifying ? (
                            <div>
                              <Spinner className="ms-2" color="primary"/>
                            </div>
                          ) : (
                            <div style={{display: "flex", alignItems: "center"}}>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleVerificationLoki}
                              >
                                Test Connection
                              </button>
                              <span
                                id="TooltipRight"
                                onMouseOver={() => settright(true)}
                                onMouseLeave={() => settright(false)}
                                className="alert-icon"
                                style={{marginLeft: "10px", display: "inline-flex", alignItems: "center"}}
                              >
                                <i className="mdi mdi-information-outline text-warning"/>
                                <Tooltip
                                  placement="top"
                                  isOpen={tright}
                                  target="TooltipRight"
                                  toggle={() => settright(!tright)}
                                  style={{
                                    border: "2px solid #f1b44c",
                                    borderRadius: "10px",
                                    backgroundColor: "#2a3042",
                                    zIndex: 1,
                                  }}
                                >
                                  We will verify your Loki credentials by attempting to access your Loki instance
                                </Tooltip>
                              </span>
                            </div>
                          )
                        ) : (
                          <div style={{alignContent: "center", display: "flex", justifyContent: "space-between"}}>
                            <div className='text-success' color="success">Verified</div>
                            <i className="mdi mdi-check-circle text-success" style={{marginLeft: "5px"}}/>
                          </div>
                        )}
                        <div className="mt-4">
                          {lastStep ? (
                            <button className="btn btn-primary login-button" disabled>
                              Saving...
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary login-button"
                              type="submit"
                              disabled={!isLokiVerified}
                            >
                              Save
                            </button>
                          )}
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>) : null}
          {currentService === 'Coralogix' ? (
            <Row className="mt-4">
              <Col lg="6">
                <div className="mb-4">
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <h3 className="">Instructions to integrate Coralogix</h3>
                    </div>
                  </div>
                  <h5>Configuration Details Required</h5>
                </div>
                <div className="mt-4 mb-2">
                  <h5>Coralogix DataPrime URL and Personal/Team API key</h5>
                  <ol>
                    <li>
                      <strong>Coralogix DataPrimeURL</strong>
                      <ul>
                        <li>Provide the complete DataPrime URL of your Coralogix instance</li>
                        <li>The URL should be in this format: <code>https://ng-api-http.app.coralogix.in</code></li>
                        <li>Make sure to use the correct domain based on your region (.in, .com)</li>
                        <li>You can find your region-specific and to create DataPrime URL <a
                          href="https://coralogix.com/docs/integrations/coralogix-endpoints/#dataprime">Here</a></li>
                        <li>This URL will be used to establish the connection to your Coralogix logging system</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Coralogix Personal/Team</strong>
                      <ul>
                        <li>Create a personal or team API key by going to profile setting in the top left and then in the left side bar in Keys section</li>
                        <li>It's recommended to use Data Querying preset, as they are automatically updated with all relevant permissions</li>
                        <li>Alternatively, you can manually add these permissions under Data Querying: Query Data from the Archive, Query Frequent Search Logs,
                          Query Monitoring & Compliance Logs
                        </li>
                        <li>This key will be used to authenticate access to your Coralogix system</li>
                      </ul>
                    </li>
                  </ol>
                </div>
              </Col>
              <Col lg="1">
              </Col>
              <Col lg="5">
                <Card>
                  <CardBody className="pt-0 account-margin">
                    <h3 className="text-primary">Enter your Coralogix credentials</h3>
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation_coralogix.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}

                        <div className="mb-3">
                          <Label className="form-label">Coralogix DataPrime URL</Label>
                          <Input
                            name="url"
                            className="form-control"
                            placeholder="DataPrime URL"
                            type="text"
                            onChange={validation_coralogix.handleChange}
                            onBlur={validation_coralogix.handleBlur}
                            value={validation_coralogix.values.url || ""}
                            invalid={
                              validation_coralogix.touched.url && validation_coralogix.errors.url ? true : false
                            }
                          />
                          {validation_coralogix.touched.url && validation_coralogix.errors.url ? (
                            <FormFeedback type="invalid">{validation_coralogix.errors.url}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Personal/Team API key</Label>
                          <Input
                            name="bearer_key"
                            className="form-control"
                            placeholder="API Key"
                            type="password"
                            onChange={validation_coralogix.handleChange}
                            onBlur={validation_coralogix.handleBlur}
                            value={validation_coralogix.values.bearer_key || ""}
                            invalid={
                              validation_coralogix.touched.bearer_key && validation_coralogix.errors.bearer_key ? true : false
                            }
                          />
                          {validation_coralogix.touched.bearer_key && validation_coralogix.errors.bearer_key ? (
                            <FormFeedback type="invalid">{validation_coralogix.errors.bearer_key}</FormFeedback>
                          ) : null}
                        </div>
                        {!isCoralogixVerified ? (
                          is_coralogix_verifying ? (
                            <div>
                              <Spinner className="ms-2" color="primary"/>
                            </div>
                          ) : (
                            <div style={{display: "flex", alignItems: "center"}}>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleVerificationCoralogix}
                              >
                                Test Connection
                              </button>
                              <span
                                id="CoralogixTooltipRight"
                                onMouseOver={() => settright(true)}
                                onMouseLeave={() => settright(false)}
                                className="alert-icon"
                                style={{marginLeft: "10px", display: "inline-flex", alignItems: "center"}}
                              >
                                  <i className="mdi mdi-information-outline text-warning"/>
                                  <Tooltip
                                    placement="top"
                                    isOpen={tright}
                                    target="CoralogixTooltipRight"
                                    toggle={() => settright(!tright)}
                                    style={{
                                      border: "2px solid #f1b44c",
                                      borderRadius: "10px",
                                      backgroundColor: "#2a3042",
                                      zIndex: 1,
                                    }}
                                  >
                                    We will verify your Coralogix credentials by attempting to access your Coralogix instance
                                  </Tooltip>
                                </span>
                            </div>
                          )
                        ) : (
                          <div style={{alignContent: "center", display: "flex", justifyContent: "space-between"}}>
                            <div className='text-success' color="success">Verified</div>
                            <i className="mdi mdi-check-circle text-success" style={{marginLeft: "5px"}}/>
                          </div>
                        )}
                        <div className="mt-4">
                          {lastStep ? (
                            <button className="btn btn-primary login-button" disabled>
                              Saving...
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary login-button"
                              type="submit"
                              disabled={!isCoralogixVerified}
                            >
                              Save
                            </button>
                          )}
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : null}
          <Loader
            isOpen={isLoading}
            lottieJson={onboardingLottie}
            messageHeader="Setting up your account"
            message="Please wait while we set up all your integrations"
          />
        </Container>

      </div>
      <svg xmlns="http://www.w3.org/2000/svg">
        <symbol id="checkmark-bold" viewBox="0 0 24 24">
          <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/>
        </symbol>
      </svg>
      <Modal
        isOpen={showDeleteModal}
        role="dialog"
        autoFocus={true}
        keyboard={false}
        centered
        backdrop="static"
        data-toggle="modal"
      >
        <ModalHeader className="text-center">
          <h5 className="mb-0">Are you sure?</h5>
        </ModalHeader>
        <ModalBody>
          <p className="text-center">
            Note that this is a <strong>permanent action</strong> and cannot be undone.
          </p>
          <div className="d-flex justify-content-center gap-3 mt-4">
            <button
              className="btn btn-danger px-4"
              onClick={() => {
                setShowDeleteModal(false);
                deleteIntegration();
              }}
            >
              Yes, Remove
            </button>
            <button
              className="btn btn-outline-secondary px-4"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>

    </React.Fragment>
  );
};
export default withRouter(DefaultOnboarding);

DefaultOnboarding.propTypes = {
  history: PropTypes.object,
};